<template>
  <div class="material">
    <div class="main-form">
      <div
        class="base-accessory-container"
        v-if="
          form_data.package_detail.filter((item) => !item.is_replace).length > 0
        "
      >
        <div class="base-accessory-title">基础辅料包内容</div>
        <div class="content-box">
          <div class="base-list-container">
            <div class="base-list">
              <div
                class="base-item"
                v-for="(item, index) in form_data.package_detail.filter(
                  (item) => !item.is_replace
                )"
                :key="index"
              >
                <div class="cover">
                  <img
                    :src="item.image | default_img"
                    alt=""
                    class="cover-img"
                  />
                  <div class="cover-buttons">
                    <div class="btn-box">
                      <div class="btn-container" v-if="!item.is_original">
                        <div
                          class="btn-item"
                          @click="open_accessory_detail(item, true)"
                        >
                          查看
                        </div>
                        <div
                          class="btn-item"
                          @click="onReplaceModeClick(item)"
                        >
                          {{ is_replace_mode ? "取消" : "替换" }}
                        </div>
                      </div>
                      <div class="btn-container" v-else>
                        <div
                          class="btn-item"
                          @click="onReplaceModeClick(item)"
                        >
                          {{ is_replace_mode ? "取消替换" : "重新替换" }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="item.is_original" class="replace-tag">已替换</div>
                </div>
                <div class="title">
                  {{ item.accessory_name }}
                </div>
                <img
                  src="@/assets/images/design/icon-del.png"
                  class="icon-del cursor"
                  @click.prevent="del_accessory_package(item)"
                />
              </div>
            </div>
          </div>
          <div
            class="base-replace-container"
            v-if="
              (form_data.package_detail || []).filter((item) => item.is_replace)
                .length > 0
            "
          >
            <div class="replace-title-box">
              <div class="replace-title-text">替换辅料:</div>
              <div class="replace-line"></div>
            </div>
            <div class="replace-list">
              <div
                class="base-item"
                v-for="(item, index) in (form_data.package_detail || []).filter(
                  (item) => item.is_replace
                )"
                :key="index"
              >
                <div class="cover">
                  <img
                    :src="item.image | default_img"
                    alt=""
                    class="cover-img"
                  />
                  <div class="cover-buttons">
                    <div class="btn-box">
                      <div class="btn-container">
                        <div class="btn-item" @click="onDeleteReplace(item)">
                          删除
                        </div>
                        <div
                          class="btn-item"
                          @click="open_accessory_detail(item)"
                        >
                          查看
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="title">
                  {{ item.accessory_name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="top-tabs">
        <div class="tab-list">
          <div
            @click="change_tab1('default')"
            :class="['tab-item', { active: current_tab1 === 'default' }]"
          >
            平台辅料
          </div>
          |
          <div
            @click="change_tab1('self')"
            :class="['tab-item', { active: current_tab1 === 'self' }]"
          >
            自己提供辅料
          </div>
          |
          <div
            @click="change_tab1('daigou')"
            :class="['tab-item', { active: current_tab1 === 'daigou' }]"
          >
            代购辅料
          </div>
        </div>
        <div class="tab-history" @click="onShowHistory">
          使用记录 <Icon type="ios-arrow-forward" color="#999" size="12px" />
        </div>
      </div>
      <div v-if="current_tab1 === 'self'" class="self-tab-box">
        <div
          :class="['self-tab-item', { active: current_tab2 === 's1' }]"
          @click="change_tab2('s1')"
        >
          自己寄出辅料
        </div>
        <div
          :class="['self-tab-item', { active: current_tab2 === 's2' }]"
          @click="change_tab2('s2')"
        >
          第三方采买辅料
        </div>
      </div>
      <div
        class="tips-third"
        v-if="current_tab1 === 'self' && current_tab2 === 's2'"
      >
        <p>可进入右侧第三方平台选购所需辅料后</p>
        <p>点击 [添加辅料] 将辅料信息提交平台</p>
      </div>
      <div class="material-list">
        <template v-if="current_tab1 === 'default'">
          <div
            class="own-material-item"
            v-for="(v, k) in form_data.accessory"
            :key="`a-${k}`"
          >
            <Icon
              type="md-close"
              class="remove-icon"
              @click.stop="del_accessory(k)"
            />
            <div class="main-info">
              <div class="main-cover">
                <img :src="v.image | default_img" v-viewer />
              </div>
              <div class="info-container">
                <div class="material-title">{{ v.accessory_name }}</div>
                <div class="row-1-col">
                  <div class="row-label">编号:</div>
                  <div class="row-value">{{ v.accessory_sku }}</div>
                </div>
                <div class="row-2-col">
                  <div class="col-item">
                    <div class="item-label">单位:</div>
                    <div class="item-value">{{ v.measure_unit }}</div>
                  </div>
                  <div class="col-item">
                    <div class="item-label">个数:</div>
                    <div class="item-value">
                      <input
                        :value="form_data.accessory[k].num"
                        @input="input2($event, 'accessory', k, 'num')"
                        placeholder="个数"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div class="row-1-col">
                  <div class="row-label">颜色:</div>
                  <div class="row-value">
                    <select
                      :value="form_data.accessory[k].color_key"
                      @input="change3($event, 'accessory', k, 'color_key')"
                    >
                      <option
                        v-for="(vv, kk) in form_data.accessory[k].color_list"
                        :key="kk"
                        :value="vv.color_key"
                      >
                        {{ vv.color_name_cn }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="use-desc">
              <div class="label">使用说明:</div>
              <input
                type="text"
                placeholder="请输入使用说明"
                :value="form_data.accessory[k].desc"
                @input="input2($event, 'accessory', k, 'desc')"
              />
            </div>
          </div>
        </template>
        <template v-else-if="current_tab1 === 'self'">
          <div
            class="custom-material-item"
            v-for="(v, k) in form_data.accessory_self"
            :key="`ms` + k"
          >
            <Icon
              type="md-close"
              class="remove-icon"
              @click.stop="del_accessory_self(k)"
            />
            <div class="custom-main-info">
              <div class="main-cover">
                <Upload
                  :action="upload_url"
                  :data="{ dir: 'template' }"
                  :before-upload="(file) => onBeforeUpload(file, k)"
                  :show-upload-list="false"
                  :format="['jpg', 'jpeg', 'png', 'gif']"
                  accept=".jpg,.jpeg,.png,.gif"
                >
                  <template v-if="v.image">
                    <div class="img-box">
                      <img @click.stop :src="v.image" class="img" v-viewer />
                      <div class="replace-btn">
                        <img
                          src="@/assets/images/icon-file-upload.png"
                          alt=""
                          class="ico"
                        />
                        重新上传
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="img-default">
                      <img
                        class="img2"
                        src="@/assets/images/design/icon-add.png"
                      />
                      <p>上传图案</p>
                    </div>
                  </template>
                </Upload>
              </div>
              <div class="custom-main-form">
                <div class="form-item">
                  <div class="item-label required">名称:</div>
                  <input
                    type="text"
                    placeholder="辅料名称"
                    :value="form_data.accessory_self[k].accessory_name"
                    @input="
                      input2($event, 'accessory_self', k, 'accessory_name')
                    "
                  />
                </div>
                <div class="form-item">
                  <div class="item-label">编号:</div>
                  <input
                    type="text"
                    placeholder="辅料编号"
                    :value="form_data.accessory_self[k].accessory_sku"
                    @input="
                      input2($event, 'accessory_self', k, 'accessory_sku')
                    "
                  />
                </div>
                <div class="form-item">
                  <div class="item-label">单位:</div>
                  <input
                    type="text"
                    placeholder="规格"
                    :value="form_data.accessory_self[k].measure_unit"
                    @input="input2($event, 'accessory_self', k, 'measure_unit')"
                  />
                </div>
                <div class="form-item">
                  <div class="item-label">个数:</div>
                  <input
                    type="text"
                    placeholder="个数"
                    :value="form_data.accessory_self[k].num"
                    @input="input2($event, 'accessory_self', k, 'num')"
                  />
                </div>
                <div class="form-item">
                  <div class="item-label">颜色:</div>
                  <select
                    class="value"
                    :value="form_data.accessory_self[k].color_key"
                    @input="change3($event, 'accessory_self', k, 'color_key')"
                  >
                    <option
                      v-for="(vv, kk) in form_data.accessory_self[k].color_list"
                      :key="kk"
                      :value="vv.color_key"
                    >
                      {{ vv.color_name_cn }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="use-desc">
              <div class="label">使用说明:</div>
              <input
                type="text"
                placeholder="请输入使用说明"
                :value="form_data.accessory_self[k].desc"
                @input="input2($event, 'accessory_self', k, 'desc')"
              />
            </div>
          </div>
          <div class="add-custom-material" @click="add_accessory_self">
            + 添加辅料
          </div>
        </template>
        <template v-else-if="current_tab1 === 'daigou'">
          <div
            class="custom-material-item"
            v-for="(v, k) in form_data.accessory_daigou"
            :key="`mdg` + k"
          >
            <Icon
              type="md-close"
              class="remove-icon"
              @click.stop="del_accessory_daigou(k)"
            />
            <div class="custom-main-info">
              <div class="main-cover">
                <template v-if="v.image_list && v.image_list.length">
                  <div class="img-box">
                    <Icon class="prev-btn" type="ios-arrow-back" @click.stop="switchImage(k,'left')"></Icon>
                    <Icon class="next-btn" type="ios-arrow-forward" @click.stop="switchImage(k,'right')"></Icon>
                    <div class="img-list" v-viewer @click.stop>
                      <template v-for="(img,ii) in v.image_list">
                        <img :key="ii" v-show="ii === (v.currentImageIndex || 0)" :src="img" class="img" />
                        <Icon type="ios-close-circle-outline" class="close-btn" @click.stop="onDelImg(k,ii)" />
                      </template>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="img-default" title="点击下方按钮上传图片">
                    <img
                      :src="''|default_img"
                    />
                  </div>
                </template>
                <Upload
                  :action="upload_url"
                  :data="{ dir: 'template' }"
                  :before-upload="(file) => onBeforeUpload2(file, k)"
                  :show-upload-list="false"
                  :format="['jpg', 'jpeg', 'png', 'gif']"
                  accept=".jpg,.jpeg,.png,.gif" multiple
                >
                  <Button title="点此上传" type="text">{{v.image_list && v.image_list.length > 0 ? '添加':'上传'}}图片</Button>
                </Upload>
              </div>
              <div class="custom-main-form">
                <div class="form-item">
                  <div class="item-label required">名称:</div>
                  <input
                    type="text"
                    placeholder="辅料名称"
                    :value="form_data.accessory_daigou[k].accessory_name"
                    @input="
                      input2($event, 'accessory_daigou', k, 'accessory_name')
                    "
                  />
                </div>
                <div class="form-item">
                  <div class="item-label">编号:</div>
                  <input
                    type="text"
                    placeholder="辅料编号"
                    :value="form_data.accessory_daigou[k].accessory_sku"
                    @input="
                      input2($event, 'accessory_daigou', k, 'accessory_sku')
                    "
                  />
                </div>
                <div class="form-item">
                  <div class="item-label">单位:</div>
                  <input
                    type="text"
                    placeholder="规格"
                    :value="form_data.accessory_daigou[k].measure_unit"
                    @input="
                      input2($event, 'accessory_daigou', k, 'measure_unit')
                    "
                  />
                </div>
                <div class="form-item">
                  <div class="item-label">个数:</div>
                  <input
                    type="text"
                    placeholder="个数"
                    :value="form_data.accessory_daigou[k].num"
                    @input="input2($event, 'accessory_daigou', k, 'num')"
                  />
                </div>
              </div>
            </div>
            <div class="use-desc">
              <div class="label">使用说明:</div>
              <input
                type="text"
                placeholder="请输入使用说明"
                :value="form_data.accessory_daigou[k].desc"
                @input="input2($event, 'accessory_daigou', k, 'desc')"
              />
            </div>
          </div>
          <div class="add-custom-material" @click="add_accessory_daigou">
            + 添加辅料
          </div>
        </template>
      </div>

      <div class="main-form-title mt-40">辅料附件上传</div>
      <Upload
        :action="upload_url"
        :data="{ dir: 'template' }"
        :before-upload="(file) => onBeforeUpload3(file)"
        :show-upload-list="false"
      >
        <div class="upload-other">
          <img
            class="icon"
            src="@/assets/images/design/icon-upload-black.png"
            alt=""
          />
          上传文件
        </div>
      </Upload>
      <div class="other-file-list">
        <div
          class="file-box"
          v-for="(v, k) in form_data.accessory_file"
          :key="`of` + k"
        >
          <a :href="v.path" class="file-item" target="_blank">
            <img :src="util.get_image_icon(v.name)" class="icon-doc" />
            {{ v.name }}
          </a>

          <img
            class="icon-del cursor"
            src="@/assets/images/design/icon-del.png"
            @click.prevent="del_accessory_file(k)"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="main-content">
      <div class="content-body">
        <div class="body-top" v-if="current_tab2 != 's2'">
          <div class="title">
            {{
              current_tab1 | body_title_filter(current_tab2, is_show_history)
            }}
          </div>
          <div v-if="!is1688 && current_tab1 != 'daigou'" class="search-box">
            <input
              v-model="form_data_accessory.keyword"
              placeholder="输入关键词进行搜索辅料"
              type="text"
              @keyup.enter="search_accessory"
            />
            <img
              alt=""
              class="icon-search"
              src="@/assets/images/icon-search.png"
              @click="search_accessory"
            />
          </div>
        </div>
        <template
          v-if="
            current_tab1 != 'daigou' && !is_show_history && current_tab2 == 's1'
          "
        >
          <div class="content-container">
            <template v-if="is_loading">
              <Spin fix>
                <Icon
                  type="ios-loading"
                  size="18"
                  class="demo-spin-icon-load"
                ></Icon>
                <div>Loading</div>
              </Spin>
            </template>
            <template v-if="current_tab1 == 'default'">
              <div class="side-category-list">
                <div
                  v-for="(v, k) in accessory_category_list"
                  :key="`dc` + k"
                  :class="[
                    'category-item',
                    {
                      active:
                        current_accessory_category_id ===
                        v.accessory_category_id,
                    },
                  ]"
                  @click="choose_accessory_category(v)"
                >
                  {{ v.category_name }}
                </div>
              </div>
              <div class="content-body-container">
                <div :class="['top-category-list',{'show-first':!show_all_cate}]">
                  <div class="flex-container">
                    <div class="top-cate-item">
                      <div class="top-cate-label">发布:</div>
                      <div class="top-cate-list">
                        <div
                          :class="[
                            'cate-list-item',
                            { active: publish_time_selected.includes(vv.value) },
                          ]"
                          v-for="(vv, kk) in publish_time_list"
                          :key="`lf2-${kk}`"
                          @click="choose_publish_time(vv)"
                        >
                          {{ vv.name }}
                        </div>
                      </div>
                    </div>
                    <div :class="['show-more-cate',{'show-all':show_all_cate}]" @click="show_all_cate=!show_all_cate">{{!show_all_cate ? '展开' :'收起'}}筛选 <Icon :type="!show_all_cate ? 'ios-arrow-down':'ios-arrow-up'" /> </div>
                  </div>
                  <div
                    class="top-cate-item"
                    v-for="(v, k) in accessory_label_list"
                    :key="`lf1-${k}`"
                  >
                    <div class="top-cate-label">{{ v.label_name }}:</div>
                    <div class="top-cate-list">
                      <div
                        v-for="(vv, kk) in v.content"
                        :class="[
                          'cate-list-item',
                          { active: accessory_label_ids.includes(vv.id) },
                        ]"
                        :key="`lf2-${kk}`"
                        @click="choose_label(vv)"
                      >
                        {{ vv.name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="list-container">
                  <div
                    v-for="(v, k) in accessory_list"
                    :class="[
                      'list-item',
                      { active: selected_ids.includes(v.id) },
                    ]"
                    @click="open_accessory_detail(v)"
                    :key="`df-${k}`"
                  >
                  <div
                      v-if="v.inventory_type == 2"
                      class="inventory-type-tag"
                    >
                      定制
                    </div>
                    <img
                      v-if="selected_ids.includes(v.id)"
                      alt=""
                      class="check-icon"
                      src="@/assets/images/icon-check.png"
                    />
                    <div class="cover-img-box">
                      <img :src="v.image | default_img" />
                      <div class="img-hover">
                        <div class="hover-btn-box">
                          <div
                            class="hover-btn-item"
                            @click.stop="open_accessory_detail(v)"
                          >
                            查看
                          </div>
                          <div
                            class="hover-btn-item"
                            @click.stop="toggle_accessory(v)"
                            v-if="selected_ids.includes(v.id)"
                          >
                            取消
                          </div>
                          <div
                            class="hover-btn-item"
                            @click.stop="toggle_accessory(v)"
                            v-else
                          >
                            选择
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="name-box">
                      <span>{{ v.accessory_name }}</span>
                    </div>
                  </div>
                </div>
                <Page
                  :current="form_data_accessory.page"
                  v-if="total > 0"
                  :page-size="form_data_accessory.size"
                  :total="total"
                  @on-change="changePage"
                  show-total
                ></Page>
              </div>
            </template>
            <template v-else-if="current_tab2 == 's1' && !is_show_history">
              <div class="wearhouse-body">
                <div class="container-tabs">
                  <div
                    v-for="(item, index) in wear_tabs"
                    :key="`wh-index-${index}`"
                    :class="[
                      'tab-item',
                      { active: item.status == query_wear_house.status },
                    ]"
                    @click="onWhTabClick(item)"
                  >
                    {{ item.name }}{{ item.has_count ? `(${item.count})` : "" }}
                  </div>
                </div>
                <div class="container-wh-list">
                  <div
                    class="list-item"
                    v-for="(item, index) in wh_list"
                    :key="`wh-list-index-${index}`"
                  >
                    <div class="cover-img">
                      <img :src="item.image | default_img" alt="" />
                      <div class="operate-btn">
                        <div
                          class="btn-item"
                          @click.stop="onWhDetailClick(item)"
                        >
                          查看
                        </div>
                        <div
                          class="btn-item"
                          @click.stop="onChooseWhItem(item)"
                        >
                          选择
                        </div>
                      </div>
                    </div>
                    <div class="item-name">{{ item.name }}</div>
                  </div>
                </div>
                <Page
                  :current="query_wear_house.page"
                  v-if="total > 0"
                  :page-size="query_wear_house.limit"
                  :total="total"
                  @on-change="changeWhPage"
                  show-total
                  style="margin-top: 20px"
                ></Page>
              </div>
            </template>
            <div v-show="is_color_show" class="color-mask">
              <div class="color-wrap">
                <h2 class="title">颜色选择</h2>
                <div class="color-list">
                  <div
                    v-for="(v, k) in current_temp_accessory.color_list"
                    :key="k"
                    :class="{
                      active:
                        current_temp_accessory.color_name_cn ===
                        v.color_name_cn,
                    }"
                    class="color-item"
                    @click="choose_color(v)"
                  >
                    <img
                      v-viewer="{ url: 'data-source' }"
                      @click.stop
                      :src="v.color_value | default_img"
                      :data-source="v.color_value"
                      alt=""
                    />
                    <span class="name">{{ v.color_name_cn }}</span>
                  </div>
                </div>
                <div class="btn-group">
                  <div class="btn btn-cancel" @click="close_color_modal">
                    取消
                  </div>
                  <div class="btn btn-confirm" @click="confirm_color">确定</div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="current_tab1 == 'self' && current_tab2 == 's2'">
          <iframe
            sandbox="allow-scripts allow-forms allow-same-origin allow-popups"
            style="width: 100%; height: 100%"
            src="https://s.1688.com/selloffer/offer_search.htm?keywords=%B8%A8%C1%CF&spm=a26352.13672862.searchbox.0"
            frameborder="0"
          ></iframe>
        </template>
        <template v-if="is_show_history">
          <div class="history-team-box">
            <div v-if="is_show_history" class="my-pattern-menu">
              <div
                :class="[
                  'menu-parent-item',
                  { active: current_pattern_menu == 1 },
                ]"
                @click="onMenuChange(1)"
              >
                <img
                  :src="
                    current_pattern_menu == 1
                      ? require('@/assets/images/team/icon-team-history-active.png')
                      : require('@/assets/images/team/icon-team-history.png')
                  "
                  alt=""
                  class="menu-icon"
                />我的历史辅料
              </div>
              <div v-if="team_list.length>0"
                :class="[
                  'menu-parent-item',
                  { active: current_pattern_menu == 2 },
                ]"
                @click="onMenuChange(2)"
              >
                <img
                  :src="
                    current_pattern_menu == 2
                      ? require('@/assets/images/team/icon-team-folder-tree-active.png')
                      : require('@/assets/images/team/icon-team-folder-tree.png')
                  "
                  alt=""
                  class="menu-icon"
                />
                <div class="label-name">
                  团队资源库<Icon
                    :type="
                      current_pattern_menu == 2
                        ? 'ios-arrow-down'
                        : 'ios-arrow-forward'
                    "
                    size="16"
                  />
                </div>
              </div>
              <ul v-if="current_pattern_menu == 2">
                <li
                  v-for="(item, index) in team_list"
                  :class="[{ 'active-team': curr_team.id == item.id }]"
                  :key="index"
                  @click="onTeamChoose(item)"
                >
                  <span>{{ item.name }}</span>
                </li>
              </ul>
            </div>
            <div style="flex: 1">
              <template v-if="is_show_history">
                <div v-if="current_pattern_menu == 1" class="history-tag-box">
                  <div class="history-tab">
                    <div
                      :class="[
                        'tag-item',
                        { active: current_history_type == -1 },
                      ]"
                      @click="current_history_type = -1"
                    >
                      全部
                    </div>
                    <div
                      :class="[
                        'tag-item',
                        { active: current_history_type == 1 },
                      ]"
                      @click="current_history_type = 1"
                    >
                      平台辅料
                    </div>
                    <div
                      :class="[
                        'tag-item',
                        { active: current_history_type == 3 },
                      ]"
                      @click="current_history_type = 3"
                    >
                      自己提供辅料
                    </div>
                  </div>
                  <div class="batch-box" v-if="false">
                    <template v-if="batch_mode">
                      <Checkbox>全选</Checkbox>
                      <div class="batch-btn">加入团队资源库</div>
                    </template>
                    <div class="batch-btn" @click="batch_mode = !batch_mode">
                      {{ batch_mode ? "退出管理" : "批量管理" }}
                    </div>
                  </div>
                </div>
                <div class="history-tag-box" v-else>
                  <div
                    :class="[
                      'tag-item-folder',
                      { 'folder-item-active': !curr_second_folder.uuid },
                    ]"
                    @click="onGetTeamFolderFileList(folder_list[0], true, true)"
                  >
                    全部({{ folder_list[0].count }})
                  </div>
                  <div
                    v-for="(item, index) in secondaryList"
                    :key="index"
                    :class="[
                      'tag-item-folder',
                      {
                        'folder-item-active':
                          curr_second_folder.uuid == item.uuid,
                      },
                    ]"
                    @click="onGetTeamFolderFileList(item, true, false)"
                  >
                    {{ item.name }}({{ item.count }})
                  </div>
                  <Icon
                    :type="show_more_folder ? 'ios-arrow-up' : 'ios-arrow-down'"
                    class="cursor"
                    size="16"
                    @click="show_more_folder = !show_more_folder"
                  />
                </div>
              </template>
              <template v-if="!uploading && current_pattern_menu == 1">
                <table align="center">
                  <thead>
                    <tr>
                      <!-- <th>款号</th> -->
                      <th>辅料信息</th>
                      <th>订单信息</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in history_list" :key="index">
                      <td>
                        <div class="info-box">
                          <img
                            :src="item.cover_img | default_img"
                            alt=""
                            class="cover-img"
                          />
                          <div class="info">
                            <div class="info-title">
                              {{ item.name || "-" }}
                              <span
                                v-if="item.type"
                                :class="[
                                  'title-tag',
                                  {
                                    platform: item.type == 1,
                                    custom: item.type == 3,
                                  },
                                ]"
                                >[{{
                                  item.type == 1 ? "平台辅料" : "客供辅料"
                                }}]</span
                              >
                            </div>
                            <div class="info-key">
                              编号:{{ item.key || "-" }}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td
                        style="
                          display: flex;
                          justify-content: center;
                          width: 100%;
                        "
                      >
                        <div style="text-align: left; width: fit-content">
                          <p><span>订单编号:</span>{{ item.order_no }}</p>
                          <p>
                            <span>使用款号:</span>{{ item.style_number || "-" }}
                          </p>
                        </div>
                      </td>
                      <td>
                        <div class="operation-col">
                          <div class="operation">
                            <div
                              v-if="!form_data_history.is_self"
                              class="btn"
                              @click="open_accessory_detail(item.data)"
                            >
                              查看
                            </div>
                            <span v-if="!form_data_history.is_self">|</span>
                            <div
                              class="btn"
                              @click="onHistorySelect(item.data)"
                            >
                              选择
                            </div>
                          </div>
                          <div
                            v-if="!form_data_history.is_self"
                            class="join-team"
                            @click="onAddTeamFile(item)"
                          >
                            加入团队资源库
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </template>
              <div
                class="team-file"
                v-else-if="!uploading && current_pattern_menu == 2"
              >
                <table>
                  <thead>
                    <tr>
                      <th
                        v-if="current_pattern_menu == 1 && batch_mode"
                        style="width: 16px; height: 16px"
                      ></th>
                      <th style="width: 40%">辅料信息</th>
                      <th>辅料类型</th>
                      <th>操作</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, index) in team_pattern_list"
                      :key="index"
                      :class="[
                        'tr-relative',
                        {
                          'tr-active':
                            form_data.pattern[0] &&
                            item.id === form_data.pattern[0].id,
                        },
                      ]"
                      @click="open_pattern_detail(item)"
                    >
                      <td>
                        <div class="info-container">
                          <img
                            :src="
                              (item.info &&
                              item.info.image &&
                              util.test_image(item.info.image)
                                ? item.info.image
                                : item.info && item.info.path
                                ? item.info.path
                                  ? util.get_image_icon(item.info.path)
                                  : ''
                                : '') | default_img(false)
                            "
                            alt=""
                            class="cover-img"
                          />
                          <div class="item-info">
                            <div class="title">
                              <div class="main" :title="item.name">
                                {{ item.name }}
                              </div>
                              <div
                                :class="[
                                  'sub',
                                  item.fabric && item.fabric.id
                                    ? 'own-pattern'
                                    : 'custom-pattern',
                                ]"
                              >
                                [{{
                                  item.fabric && item.fabric.id
                                    ? "平台辅料"
                                    : "客供辅料"
                                }}]
                              </div>
                            </div>
                            <div class="info">
                              编号:{{ item.info.fabric_key || "-" }}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="style-col">
                          {{ item.file_folder_name || "-" }}
                        </div>
                      </td>
                      <td>
                        <div class="operation-col">
                          <div class="left-operation">
                            <template v-if="item.fabric && item.fabric.id">
                              <div
                                class="btn"
                                @click.stop="onTeamFileView(item)"
                              >
                                查看
                              </div>
                              <div class="line">|</div>
                            </template>
                            <div
                              class="btn"
                              @click.stop="
                                onTeamFileChoose({
                                  ...item.fabric,
                                  ...item.info,
                                })
                              "
                            >
                              {{
                                item.fabric &&
                                selected_ids.includes(item.fabric.id)
                                  ? "取消"
                                  : "选择"
                              }}
                            </div>
                          </div>
                        </div>
                        <img
                          v-if="
                            item.fabric && selected_ids.includes(item.fabric.id)
                          "
                          src="@/assets/images/icon-check.png"
                          alt=""
                          class="selected-icon"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <template v-else>
                <Spin fix v-if="uploading">
                  <Icon
                    type="ios-loading"
                    size="40"
                    class="spin-icon-load"
                  ></Icon>
                  <div>数据加载中...</div>
                </Spin>
              </template>
              <div class="page-container">
                <Page
                  :current="form_data_history.page"
                  v-if="total > 0"
                  :page-size="form_data_history.size"
                  :total="total"
                  @on-change="changeHistoryPage"
                  show-total
                  style="margin-top: 20px"
                ></Page>
              </div>
            </div>
          </div>
        </template>
        <template v-if="current_tab1 === 'daigou'">
          <div class="daigou-content">
            <img
              src="@/assets/images/icon-daigou-introduction.png"
              alt=""
              class="daigou-img"
            />
            <div class="daigou-sub-title">代购辅料服务说明</div>
            <p>
              本平台支持全球优质辅料代购服务！无论您需要稀缺进口辅料、小众设计师辅料，还是特定材质
              / 花色辅料等,
            </p>
            <p>
              均可在左侧点击添加辅料，根据提示填写信息，提交需求，我们专业团队全程对接采购、质检、物流等，
            </p>
            <p>助力您的设计创作无物料顾虑，让您的创意落地无阻碍！</p>
          </div>
        </template>
      </div>
    </div>
    <popup
      :show.sync="is_popup_show_detail"
      height="680px"
      width="980px"
      @on-close="close_accessory_detail"
    >
      <div class="fabric-content-wrap" ref="detailPopupContent">
        <div class="popup-scroll-content">
        <div class="info-wrap">
          <div class="left-popup">
            <div
              v-if="
                (current_temp_accessory.image_list &&
                  current_temp_accessory.image_list.length > 0) ||
                current_temp_accessory.video
              "
              class="slider"
            >
              <swiper ref="swiper" :options="swiperOption">
                <swiper-slide v-if="current_temp_accessory.video">
                  <video
                    v-if="current_temp_accessory.video"
                    :src="current_temp_accessory.video"
                    muted
                    autoplay
                    controls
                    id="video-material"
                  >
                    您的浏览器不支持视频播放。
                  </video>
                </swiper-slide>
                <swiper-slide
                  v-for="(item, index) in current_temp_accessory.image_list"
                  :key="`sl` + index"
                >
                  <img v-viewer :src="item.url" class="img" />
                </swiper-slide>
                <!--                                    <div class="swiper-pagination" slot="pagination"></div>-->
                <div slot="button-prev" class="swiper-button-prev"></div>
                <div slot="button-next" class="swiper-button-next"></div>
              </swiper>
            </div>
          </div>
          <div class="right">
            <p class="name">{{ current_temp_accessory.accessory_name }}</p>
            <p class="no">辅料编号：{{ current_temp_accessory.accessory_sku }}</p>
            <p class="price" v-if="current_temp_accessory.price>0">
              价格:¥{{ current_temp_accessory.price}}
            </p>
            <p class="price" v-else>市价</p>
            <div
              class="title"
              style="border-top: 1px solid #e0e0e0; margin-bottom: 20px"
            >
              <!-- 辅料参数 -->
            </div>
            <div class="list">
              <div class="item">
                <span class="key">单位：</span
                ><span class="value">{{
                  current_temp_accessory.measure_unit
                }}</span>
              </div>
              <div class="item">
                <span class="key">规格：</span
                ><span class="value">{{ current_temp_accessory.spec }}</span>
              </div>
              <div class="item">
                <span class="key">材质：</span
                ><span class="value">{{
                  current_temp_accessory.material
                }}</span>
              </div>
              <!-- <div class="color-title">颜色选择:</div>
                            <div class="color-box">
                                <div v-for="(item,index) in current_temp_accessory.color_list" :key="index" @click="choose_color(item)" :class="['color-item',{active:current_temp_accessory.color_name_cn === item.color_name_cn}]">
                                    <img v-viewer="{url: 'data-source'}" @click.stop :src="item.color_value|default_img" :data-source="item.color_value" alt="" class="color-img" />{{ item.color_name_cn }}
                                </div>
                            </div> -->
            </div>
          </div>
        </div>
        <div class="title-box">
          <div class="title">颜色选择</div>
          <div class="line"></div>
        </div>
        <div class="color-box">
          <div
            v-for="(item, index) in current_temp_accessory.color_list"
            :key="index"
            @click="choose_color(item)"
            :class="[
              'color-item',
              {
                active:
                  current_temp_accessory.color_name_cn === item.color_name_cn,
              },
            ]"
          >
            <img
              v-viewer="{ url: 'data-source' }"
              @click.stop
              :src="item.color_value | default_img"
              :data-source="item.color_value"
              alt=""
              class="color-img"
            />{{ item.color_name_cn }}
          </div>
        </div>
        <div class="title-box">
          <div class="title">产品详情</div>
          <div class="line"></div>
        </div>
        <div
          class="richtext-wrap"
          v-html="current_temp_accessory.description"
        ></div>
        </div>
        <div class="btn-box">
          <button class="cancel-btn" @click="close_accessory_detail">
            取消
          </button>
          <button class="confirm-btn" @click="confirm_color_detail">
            确认选择
          </button>
        </div>
      </div>
    </popup>
    <!-- 团队文件夹弹窗 -->
    <move-file
      ref="moveFilePop"
      v-if="show_move_file"
      :file="curr_file"
      :teamId="ownTeam.uuid"
      :teamName="ownTeam.name"
      :rootFolderType="2"
      @on-move-success="onGetTeamFolderFileList"
      @on-close="show_move_file = false"
    />
  </div>
</template>
<script>
import {
    AccessoryCategoryList,
    AccessoryLabelList,
    AccessoryList,
    folderFileCount,
    getDesignHistory,
    GetOwnerMaterialList,
    teamFileListForDesgin,
    teamFolderFileList,
    teamList,
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import { uploadFileToOSS } from "@/utils/oss";
import util from "@/utils/util";
import axios from "axios";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";
import Lesson from "./Lesson.vue";
import MoveFile from "./MoveFile.vue";
export default {
  name: "Accessory",
  data() {
    return {
      util: util,
      swiperOption: {
        loop: false, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          slideChange: function () {
            if (document.getElementById("video-accessory")) {
              if (this.activeIndex === 0) {
                document.getElementById("video-accessory").play();
              } else {
                document.getElementById("video-accessory").pause();
              }
            }
          },
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      },
      upload_url: process.uniEnv.BASE_API + "/util/upload-image",
      form_data_accessory: {
        page: 1,
        size: 20,
        keyword: "",
        accessory_category_id: 0,
      },
      total: -1,
      accessory_label_list: [],
      accessory_label_ids: [],
      sub_accessory_category_list: [],
      accessory_category_list: [],
      accessory_list: [],
      current_accessory_category_id: 0,
      current_sub_accessory_category_id: 0,
      current_temp_accessory: {
        image_list: [],
      },
      is_popup_show_detail: false,
      is_color_show: false,
      current_tab1: "default",
      width: "600px",
      is1688: false,
      current_tab2: "s1",
      is_replace_mode: false,
      current_package_index: "",
      current_package: {},
      publish_time_list: [
        { name: "3个月", value: "3" },
        { name: "6个月", value: "6" },
        { name: "9个月", value: "9" },
        { name: "1年", value: "12" },
        { name: "1年以上", value: "12+" },
      ],
      publish_time_selected: [],
      form_data_history: {
        page: 1,
        size: 20,
        keyword: "",
        type: "accessory",
        is_self: false,
        is_all: true,
      },
      history_list: [],
      is_show_history: false,
      uploading: false,
      is_from_package: false,
      current_history_type: -1,
      current_pattern_menu: 1,
      team_list: [],
      curr_team: {},
      folder_list: [],
      show_move_file: false,
      curr_file: {},
      secondary_folder_list: [],
      curr_second_folder: {},
      team_file_list: [],
      show_more_folder: false,
      team_pattern_list: [],
      batch_mode: false,
      is_show_wear_house: false,
      wear_tabs: [
        { name: "全部辅料", value: "all", status: 99 },
        {
          name: "未入仓",
          value: "un-in",
          status: 0,
          has_count: true,
          count: 0,
        },
        { name: "已入仓", value: "in", status: 1, has_count: true, count: 0 },
      ],
      query_wear_house: {
        type: "2",
        keyword: "",
        page: 1,
        limit: 10,
        status: 99,
      },
      wh_list: [],
      is_loading: false,
      uploadQueue:[],
      debounceTimer: null, // 防抖定时器
      debounceTime: 300, // 防抖时间（毫秒）
      show_all_cate:false
    };
  },
  filters: {
    body_title_filter(tab1, tab2, is_show_history) {
      if (is_show_history) {
        return "辅料使用记录";
      }
      switch (tab1) {
        case "daigou":
          return "平台代购辅料服务";
        case "self":
          if (tab2 == "s2") {
            return "辅料选择";
          }
          return "我的辅料";
        default:
          return "辅料选择";
      }
    },
  },
  components: {
    Popup,
    swiper,
    swiperSlide,
    Lesson,
    MoveFile,
  },
  computed: {
    ...mapState({
      form_data: (state) => state.design.form_data,
      height: (state) => state.design.height,
      is_lesson_show: (state) => state.design.is_lesson_show,
      product_category_list: (state) => state.design.product_category_list,
    }),
    selected_ids() {
      return this.form_data.accessory.map((v) => v.id);
    },
    hasOwnTeam() {
      const { team_list } = this;
      return team_list.filter((item) => item.role === "所有者").length > 0;
    },
    folderList() {
      return this.folder_list.filter((item) => item.is_dir);
    },
    fileList() {
      return this.folder_list.filter((item) => !item.is_dir);
    },
    ownTeam() {
      const { team_list } = this;
      return team_list.find((item) => item.role === "所有者");
    },
    secondaryList() {
      if (this.show_more_folder) {
        return this.secondary_folder_list;
      } else {
        return this.secondary_folder_list.slice(0, 5);
      }
    },
  },
  watch: {
    current_history_type(news, olds) {
      this.form_data_history.is_self = news == 4;
      this.form_data_history.is_all = news == -1;
      this.searchHistory(true);
    },
    is_show_wear_house(news, olds) {
      if (news) {
        this.onGetWearHouseList();
      }
    },
  },
  methods: {
    onDelImg(k, i) {
      const list = this.form_data.accessory_daigou;
      if (!list || !list[k] || !list[k].image_list) return;

      const currentObj = list[k];
      const imgList = currentObj.image_list;

      if (i < 0 || i >= imgList.length) return;

      imgList.splice(i, 1);
      let newIndex = currentObj.currentImageIndex || 0;

      if (imgList.length === 0) {
        newIndex = 0;
      } else {
        if (i <= newIndex) {
          newIndex = Math.max(0, newIndex - 1);
        }

        if (newIndex >= imgList.length) {
          newIndex = imgList.length - 1;
        }
      }

      this.$set(currentObj, 'currentImageIndex', newIndex);

      if (imgList.length > 0) {
        currentObj.image = imgList[0];
      } else {
        currentObj.image = "";
      }

      this.$store.commit("design/arr_update_one", {
        key: "accessory_daigou",
        index: k,
        value: { ...currentObj },
      });
    },
    switchImage(k, direction) {
      const list = this.form_data.accessory_daigou;
      if (!list || !list[k]) return;

      const item = list[k];
      if (!item.image_list || item.image_list.length <= 1) return;

      let currentIndex = Number(item.currentImageIndex) || 0;
      const total = item.image_list.length;

      let newIndex;
      if (direction === 'left') {
        newIndex = (currentIndex - 1 + total) % total;
      } else {
        newIndex = (currentIndex + 1) % total;
      }

      this.$set(item, 'currentImageIndex', newIndex);

      this.$set(item, 'image', item.image_list[newIndex]);

      this.$forceUpdate();
    },
    changeWhPage(page) {
      this.query_wear_house.page = page;
      this.onGetWearHouseList();
    },
    onWhItemBuild(material) {
      const { name, no, image } = material;
      const new_material = {
        image,
        accessory_sku: no,
        accessory_name: name,
        measure_unit: "",
        num: 1,
        desc: "",
        color_key: "",
        color_name_cn: "",
        color_value: "",
        color_list: material.color.map((item) => {
          return {
            color_key: item.no,
            color_name_cn: item.name,
            color_value: item.image,
          };
        }),
      };
      return new_material;
      // this.current_temp_accessory = new_material;
    },
    onChooseWhItem(material) {
      this.current_temp_accessory = this.onWhItemBuild(material);
      if (
        this.form_data.accessory.length +
          this.form_data.accessory_self.length +
          this.form_data.accessory_daigou.length >=
        10
      ) {
        this.$layer.msg(`最多可添加10种辅料`);
        return;
      }
      let object = this.current_temp_accessory;
      this.$store.commit("design/arr_push_one", {
        key: "accessory_self",
        value: object,
      });
      // this.is_color_show = true;
    },
    onWhDetailClick(material) {
      console.log("material", material);
      this.current_temp_accessory = this.onWhItemBuild(material);
      this.is_popup_show_detail = true;
    },
    async onGetWearHouseList() {
      try {
        this.is_loading = true;
        const { code, msg, data } = await GetOwnerMaterialList({
          ...this.query_wear_house,
        });
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        console.log("data--wearhouse", data);
        if (data.list.length) {
          this.wh_list = data.list;
        }
        this.total = data.count;
      } catch (e) {
        console.log("err-wear-house-list", e);
        this.$layer.msg(e.msg);
      } finally {
        this.is_loading = false;
      }
    },
    onWhTabClick({ value }) {
      switch (value) {
        case "un-in":
          this.query_wear_house.status = 0;
          break;
        case "in":
          this.query_wear_house.status = 1;
          break;
        default:
          this.query_wear_house.status = 99;
          break;
      }
      this.onGetWearHouseList();
      // this.query_wear_house.type=value;
    },
    del_accessory_package(item) {
      const index = this.$store.state.design.form_data.package_detail.findIndex(
        (i) => i.id === item.id
      );
      if (index !== -1) {
        this.$store.commit("design/arr_remove_one", {
          key: "package_detail",
          index: index,
        });
      }
    },
    async onGetFileCount() {
      try {
        // folderFileCount
        const { curr_team, folderList } = this;
        const param = {};
        param.team_uuid = curr_team.uuid;
        param.folder_uuid = folderList[0].uuid;
        // console.log('param-count===>',param);
        const { code, msg, data } = await folderFileCount(param);
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        // console.log('data-count===>',data);
        const countMap = {};
        data.forEach((item) => {
          const [id, count] = Object.entries(item)[0];
          countMap[Number(id)] = count;
        });

        this.folder_list[0].count = countMap[this.folder_list[0].id] || 0;

        // 更新 secondary_folder_list 中每个项目的 count 值
        this.secondary_folder_list = this.secondary_folder_list.map((item) => {
          const count = countMap[item.id] || 0;
          return {
            ...item,
            count: count,
          };
        });

        // console.log('updated secondary_folder_list:', this.secondary_folder_list);
      } catch (e) {
        console.log("err-get-file-count", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      }
    },
    async onGetTeamFileForDesign(is_all = false) {
      try {
        this.is_loading = true;
        const { curr_second_folder, curr_team, folderList, form_data_history } =
          this;
        const { page, size, keyword } = form_data_history;
        const param = {};
        param.page = page;
        param.size = size;
        param.keyword = keyword;
        param.team_uuid = curr_team.uuid;
        param.folder_uuid = is_all
          ? folderList[0].uuid
          : curr_second_folder.uuid || folderList[0].uuid;
        const { code, msg, data } = await teamFileListForDesgin(param);
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        console.log("data", data);
        this.team_pattern_list = data.list;
        this.total = data.count;
      } catch (e) {
        console.log("err-get-team-file-list-design", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      } finally {
        this.is_loading = false;
      }
    },
    onAddTeamFile(file) {
      this.curr_file = file;
      this.show_move_file = true;
    },
    async onTeamChoose(team) {
      if (!team) return;
      this.curr_team = team;
      await this.onGetTeamFolderFileList();
      await this.onGetTeamFolderFileList(this.folder_list[0], false, true);
      await this.onGetTeamFolderFileList(
        this.secondary_folder_list[0],
        true,
        true
      );
      await this.onGetFileCount();
      await this.onGetTeamFileForDesign();
    },
    async onGetTeamFolderFileList(
      folder = {},
      is_file = false,
      is_all = false
    ) {
      try {
        if (!this.curr_team) return;
        if (!is_all) {
          this.curr_second_folder = folder;
        } else {
          this.curr_second_folder = {};
        }
        if (is_file) {
          this.onGetTeamFileForDesign(false);
        }
        const param = {};
        param.team_uuid = this.curr_team.uuid;
        param.parent_directory_uuid = folder.uuid || "";
        const { code, msg, data } = await teamFolderFileList(param);
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        if (!folder || !folder.uuid) {
          this.folder_list = data.filter((item) => item.type == 3);
        } else {
          if (!is_file) {
            this.secondary_folder_list = data.filter((item) => item.is_dir);
          }
        }
      } catch (e) {
        console.log("err-get-file-folder-list", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      }
    },
    async onGetTeamList() {
      try {
        const { code, msg, data } = await teamList();
        if (code > 0) {
          this.$layer.msg(msg);
          return;
        }
        console.log("data-team-list", data);
        if (!data.length) {
          this.team_list = [];
          this.curr_team = {};
          return;
        }
        this.team_list = data;
        let curr_team = data.filter((item) => item.role === "所有者")[0];
        if (!curr_team) {
          curr_team = data[0];
        }
        this.curr_team = curr_team;
      } catch (e) {
        console.log("err-team-list", e);
        this.$layer.msg(e.msg || JSON.stringify(e));
      }
    },
    async onMenuChange(type) {
      if (type == 1) {
        this.searchHistory(false);
      } else {
        await this.onGetTeamList();
        if (!this.team_list.length) {
          this.$layer.msg("您还未加入任何团队，请先创建或加入团队");
          return;
        }
        await this.onGetTeamFolderFileList();
        await this.onGetTeamFolderFileList(this.folder_list[0], false, true);
        await this.onGetTeamFolderFileList(
          this.secondary_folder_list[0],
          true,
          true
        );
        await this.onGetFileCount();
        await this.onGetTeamFileForDesign();
      }
      this.current_pattern_menu = type;
    },
    async onTeamFileChoose(data) {
      console.log("team-file-choose-data", data);
      console.log("onTeamFileChoose 数据的所有字段:", Object.keys(data));
      
      if (!data.relate_id) {
        if (
          this.form_data.accessory.length +
            this.form_data.accessory_self.length >=
          10
        ) {
          this.$layer.msg(`最多可添加10种辅料`);
          return;
        }
        
        // 处理有 info 对象的情况
        let target_data = data;
        if (data.info) {
          console.log("检测到 data.info 对象，使用 info 里的数据");
          target_data = data.info;
        }
        
        // 尝试多种可能的图片字段名
        let accessory_image = target_data.image || "";
        if (!accessory_image && target_data.path) {
          accessory_image = target_data.path;
        }
        if (!accessory_image && target_data.cover_img) {
          accessory_image = target_data.cover_img;
        }
        if (!accessory_image && target_data.cover) {
          accessory_image = target_data.cover;
        }
        if (!accessory_image && target_data.img) {
          accessory_image = target_data.img;
        }
        if (!accessory_image && target_data.img_url) {
          accessory_image = target_data.img_url;
        }
        if (!accessory_image && target_data.image_url) {
          accessory_image = target_data.image_url;
        }
        if (!accessory_image && target_data.image_list && target_data.image_list[0]) {
          accessory_image = target_data.image_list[0].url || target_data.image_list[0].src || target_data.image_list[0];
        }
        if (!accessory_image && target_data.images && target_data.images[0]) {
          accessory_image = target_data.images[0].url || target_data.images[0].src || target_data.images[0];
        }
        
        console.log("onTeamFileChoose 最终使用的图片:", accessory_image);
        
        this.current_tab2 = "s1";
        let object = {
          image: accessory_image,
          accessory_sku: target_data.accessory_sku || target_data.key || "",
          accessory_name: target_data.accessory_name || target_data.name || "",
          measure_unit: target_data.measure_unit || "",
          num: target_data.num || 0,
          desc: target_data.desc || target_data.description || "",
        };
        
        console.log("onTeamFileChoose 最终构建的客供辅料对象:", object);
        
        this.$store.commit("design/arr_push_one", {
          key: "accessory_self",
          value: object,
        });
        this.change_tab1("self");
        this.change_tab2("s1");
      } else {
        this.toggle_accessory(data);
      }
    },
    onTeamFileView(data) {
      if (data.fabric) {
        this.open_accessory_detail(data.accessory);
      }
    },
    onHistorySelect(data) {
      console.log("history", data);
      const { form_data_history } = this;
      const { is_self } = form_data_history;
      if (is_self) {
        if (
          this.form_data.accessory.length +
            this.form_data.accessory_self.length >=
          10
        ) {
          this.$layer.msg(`最多可添加10种辅料`);
          return;
        }
        this.current_tab2 = "s1";
        let object = {
          image: data.cover_img,
          accessory_sku: data.key || "",
          accessory_name: data.name || "",
          measure_unit: data.measure_unit || "",
          num: data.num || 0,
          desc: data.desc || "",
        };
        this.$store.commit("design/arr_push_one", {
          key: "accessory_self",
          value: object,
        });
      } else {
        this.toggle_accessory(data);
      }
    },
    onShowHistory() {
      const { current_tab1, current_tab2 } = this;
      if (current_tab2 == "s2") {
        this.change_tab2("s1");
      }
      if (current_tab1 === "self") {
        this.form_data_history.is_self = true;
      } else {
        this.form_data_history.is_self = false;
      }
      if (this.is_lesson_show) this.$store.commit("design/hide_lesson");
      this.form_data_history.page = 1;
      this.is_show_history = true;
      this.searchHistory();
    },
    changeHistoryPage(page) {
      // console.log('changeHistoryPage',e);
      console.log("this.form_data_history", this.form_data_history);
      this.form_data_history.page = page;
      this.searchHistory();
    },
    async searchHistory(is_search = false) {
      console.log("searchHistory", this.form_data_history.keyword);
      if (is_search) {
        this.form_data_history.page = 1;
      }
      try {
        this.uploading = true;
        const { data } = await getDesignHistory({ ...this.form_data_history });
        console.log("data-history", data);
        this.total = data.total;
        console.log("total===>history", this.total);
        this.history_list = data.list;
        this.uploading = false;
      } catch (e) {
        console.log("err-history", e);
        this.uploading = false;
      }
    },
    choose_publish_time(data) {
      if (this.publish_time_selected.includes(data.value)) {
        this.publish_time_selected = this.publish_time_selected.filter(
          (item) => {
            return item !== data.value;
          }
        );
      } else {
        this.publish_time_selected.push(data.value);
      }
      this.getAccessoryList();
    },
    onDeleteReplace(data) {
      this.$store.commit("design/delete_replace_package", data);
    },
    onReplaceModeClick(data) {
      const index = this.$store.state.design.form_data.package_detail.findIndex(
        (i) => i.id === data.id
      );
      console.log("data==>", data, "index==>", index);
      this.$layer.msg("请从右侧选择要替换的辅料");
      this.current_package = data;
      this.is_replace_mode = !this.is_replace_mode;
      this.current_package_index = index;
    },
    change_tab2(c) {
      this.current_tab2 = c;
      this.is1688 = c === "s2";
      if (this.is_show_wear_house) {
        this.is_show_wear_house = false;
      }
      console.log("tab-222", c);
      if (c === "s1") {
        if (this.is_show_history) {
          return;
        }
        console.log("自己寄出辅料.展示列表");
        if (this.current_tab1 === "self") {
          this.is_show_wear_house = true;
        } else {
          this.is_show_wear_house = false;
        }
        // this.$store.commit("design/show_lesson");
      } else {
        this.$store.commit("design/hide_lesson");
      }
    },
    change_tab1(c) {
      this.current_tab1 = c;
      if (this.is_show_history) {
        this.is_show_history = false;
      }
      if (this.is_show_wear_house) this.is_show_wear_house = false;
      this.reset_temp_accessory();
      if (c === "default") {
        this.change_tab2("s1");
        this.$store.commit("design/hide_lesson");
      } else {
        // console.log('is_self',c);
        if (c === "daigou") {
          this.change_tab2("s1");
          return;
        }
        this.change_tab2("s2");
      }
    },
    choose_label(v) {
      if (this.accessory_label_ids.includes(v.id)) {
        this.accessory_label_ids = this.accessory_label_ids.filter((item) => {
          return item !== v.id;
        });
      } else {
        this.accessory_label_ids.push(v.id);
        this.accessory_label_ids = [...new Set(this.accessory_label_ids)];
      }
      this.form_data_accessory.page = 1;
      this.getAccessoryList();
    },
    del_accessory(k) {
      this.$DModal.confirm({
        content: "是否取消已选数据？",
        onOK: async () => {
          this.$store.commit("design/arr_remove_one", {
            key: "accessory",
            index: k,
          });
        },
      });
    },
    toggle_accessory(v) {
      if (this.selected_ids.includes(v.id)) {
        let idx = this.form_data.accessory.findIndex((obj) => obj.id === v.id);
        this.del_accessory(idx);
      } else {
        this.open_color_modal(v);
      }
    },
    open_color_modal(accessory) {
      this.current_temp_accessory = Object.assign({}, accessory);
      if (
        this.current_temp_accessory.color_list &&
        this.current_temp_accessory.color_list.length > 1
      ) {
        this.is_color_show = true;
      } else if (
        this.current_temp_accessory.color_list &&
        this.current_temp_accessory.color_list.length === 0
      ) {
        this.choose_color({
          color_name_cn: "",
          color_value: "",
          color_key: "",
        });
        this.confirm_color();
      } else {
        this.choose_color(this.current_temp_accessory.color_list[0]);
        this.confirm_color();
      }
    },
    choose_color(v) {
      this.$set(this.current_temp_accessory, "color_name_cn", v.color_name_cn);
      this.$set(this.current_temp_accessory, "color_value", v.color_value);
      this.$set(this.current_temp_accessory, "color_key", v.color_key);
    },
    confirm_color() {
      if (
        this.form_data.accessory.length +
          this.form_data.accessory_self.length >=
        10
      ) {
        this.$layer.msg(`最多可添加10种辅料`);
        return;
      }
      let object = { ...this.current_temp_accessory, desc: "", num: 1 };
      if (this.is_show_wear_house) {
        this.add_accessory_self();
        // this.is_color_show = false;
        return;
      }
      if (this.is_replace_mode) {
        this.$store.commit("design/package_replace", {
          index: this.current_package_index,
          data: { is_original: true },
          value: {
            ...object,
            is_replace: true,
            replace_id: this.current_package.id,
          },
        });
        this.is_replace_mode = false;
        this.is_color_show = false;
        this.reset_temp_accessory();
        return;
      }
      this.$store.commit("design/arr_push_one", {
        key: "accessory",
        value: object,
      });
      this.is_color_show = false;
      this.reset_temp_accessory();
    },
    confirm_color_detail() {
      if (
        this.form_data.accessory.length +
          this.form_data.accessory_self.length >=
        10
      ) {
        this.$layer.msg(`最多可添加10种辅料`);
        return;
      }
      let object = { ...this.current_temp_accessory, desc: "", alias: "" };
      if (this.is_show_wear_house) {
        this.add_accessory_self();
        this.is_popup_show_detail = false;
        return;
      }
      this.$store.commit("design/arr_push_one", {
        key: "accessory",
        value: object,
      });
      this.is_popup_show_detail = false;
      this.reset_temp_accessory();
    },
    close_color_modal() {
      this.is_color_show = false;
      this.reset_temp_accessory();
    },
    
    // 处理从 localStorage 读取的辅料数据
    processSelectedAccessory(accessory) {
      console.log("processSelectedAccessory", accessory);
      
      // 判断辅料类型并处理
      if (accessory.id) {
        // 平台辅料（有 id 字段）
        this.processPlatformAccessory(accessory);
      } else if (accessory.info) {
        // 团队辅料（有 info 字段）
        this.processTeamAccessory(accessory);
      } else {
        // 从详情页跳转的辅料
        this.processCustomAccessory(accessory);
      }
    },
    
    // 处理平台辅料
    processPlatformAccessory(accessory) {
      this.toggle_accessory(accessory);
    },
    
    // 处理团队辅料
    processTeamAccessory(accessory) {
      // 直接使用团队辅料的数据结构
      this.onTeamFileChoose(accessory);
    },
    
    // 处理自定义辅料（从详情页跳转）
    processCustomAccessory(accessory) {
      console.log("处理自定义辅料:", accessory);
      console.log("辅料数据的所有字段:", Object.keys(accessory));
      
      // 先处理有 info 对象的情况
      let target_accessory = accessory;
      if (accessory.info) {
        console.log("检测到 accessory.info 对象，使用 info 里的数据");
        target_accessory = accessory.info;
      }
      
      console.log("目标辅料数据:", target_accessory);
      console.log("目标辅料数据的所有字段:", Object.keys(target_accessory));
      
      console.log("尝试查找图片字段:", {
        image: target_accessory.image,
        path: target_accessory.path,
        cover_img: target_accessory.cover_img,
        cover: target_accessory.cover,
        image_list: target_accessory.image_list,
        images: target_accessory.images,
        img: target_accessory.img,
        img_url: target_accessory.img_url,
        image_url: target_accessory.image_url,
      });
      
      // 从详情页跳转过来的辅料，直接添加到客供辅料中
      if (
        this.form_data.accessory.length + this.form_data.accessory_self.length >= 10
      ) {
        this.$layer.msg(`最多可添加10种辅料`);
        return;
      }
      
      // 尝试多种可能的图片字段名
      let accessory_image = target_accessory.image || "";
      if (!accessory_image && target_accessory.path) {
        accessory_image = target_accessory.path;
      }
      if (!accessory_image && target_accessory.cover_img) {
        accessory_image = target_accessory.cover_img;
      }
      if (!accessory_image && target_accessory.cover) {
        accessory_image = target_accessory.cover;
      }
      if (!accessory_image && target_accessory.img) {
        accessory_image = target_accessory.img;
      }
      if (!accessory_image && target_accessory.img_url) {
        accessory_image = target_accessory.img_url;
      }
      if (!accessory_image && target_accessory.image_url) {
        accessory_image = target_accessory.image_url;
      }
      if (!accessory_image && target_accessory.image_list && target_accessory.image_list[0]) {
        accessory_image = target_accessory.image_list[0].url || target_accessory.image_list[0].src || target_accessory.image_list[0];
      }
      if (!accessory_image && target_accessory.images && target_accessory.images[0]) {
        accessory_image = target_accessory.images[0].url || target_accessory.images[0].src || target_accessory.images[0];
      }
      
      console.log("最终使用的图片:", accessory_image);
      
      // 构建客供辅料对象，确保图片正确传递
      let object = {
        image: accessory_image,
        accessory_sku: target_accessory.accessory_sku || target_accessory.key || "",
        accessory_name: target_accessory.accessory_name || target_accessory.name || "客供辅料",
        measure_unit: target_accessory.measure_unit || "",
        num: target_accessory.num || 0,
        desc: target_accessory.desc || target_accessory.description || "",
      };
      
      console.log("最终构建的客供辅料对象:", object);
      
      // 添加到客供辅料
      this.$store.commit("design/arr_push_one", {
        key: "accessory_self",
        value: object,
      });
      
      // 切换到客供辅料标签页
      this.change_tab1("self");
      this.change_tab2("s1");
    },
    add_accessory_self() {
      if (
        this.form_data.accessory.length +
          this.form_data.accessory_self.length +
          this.form_data.accessory_daigou.length >=
        10
      ) {
        this.$layer.msg(`最多可添加10种辅料`);
        return;
      }
      let object = {
        image: "",
        accessory_sku: "",
        accessory_name: "客供辅料",
        measure_unit: "",
        num: 1,
        desc: "",
      };
      if (this.is_show_wear_house && this.current_temp_accessory) {
        object = { ...this.current_temp_accessory };
      }
      this.$store.commit("design/arr_push_one", {
        key: "accessory_self",
        value: object,
      });
    },
    del_accessory_self(k) {
      this.$store.commit("design/arr_remove_one", {
        key: "accessory_self",
        index: k,
      });
    },
    add_accessory_daigou() {
      if (
        this.form_data.accessory.length +
          this.form_data.accessory_self.length +
          this.form_data.accessory_daigou.length >=
        10
      ) {
        this.$layer.msg(`最多可添加10种辅料`);
        return;
      }
      let object = {
        image: "",
        accessory_sku: "",
        accessory_name: "代购辅料",
        measure_unit: "",
        num: 1,
        desc: "",
      };
      if (this.is_show_wear_house && this.current_temp_accessory) {
        object = { ...this.current_temp_accessory };
      }
      this.$store.commit("design/arr_push_one", {
        key: "accessory_daigou",
        value: object,
      });
    },
    del_accessory_daigou(k) {
      this.$store.commit("design/arr_remove_one", {
        key: "accessory_daigou",
        index: k,
      });
    },
    open_accessory_detail(v, from_package = false) {
      this.current_temp_accessory = v;
      if (
        this.current_temp_accessory.color_list &&
        this.current_temp_accessory.color_list.length === 1
      ) {
        this.choose_color(this.current_temp_accessory.color_list[0]);
      }
      if (from_package) {
        this.is_from_package = true;
      }
      this.is_popup_show_detail = true;
      this.$nextTick(() => {
        const el = this.$refs.detailPopupContent;
        if (el) el.scrollTop = 0;
      });
    },
    close_accessory_detail() {
      this.reset_temp_accessory();
      this.is_popup_show_detail = false;
      if (this.is_from_package) {
        this.is_from_package = false;
      }
    },
    reset_temp_accessory() {
      this.current_temp_accessory = { image_list: [] };
    },
    changePage(page) {
      this.form_data_accessory.page = page;
      this.getAccessoryList();
    },
    search_accessory() {
      this.getAccessoryList();
    },
    choose_accessory_category(category) {
      this.current_accessory_category_id =
        this.form_data_accessory.accessory_category_id =
          category.accessory_category_id;
      if (category.accessory_category_id === 0) {
        this.sub_accessory_category_list = [];
      } else {
        this.sub_accessory_category_list = category.children;
      }
      this.current_sub_accessory_category_id = 0;
      this.form_data_accessory.page = 1;
      this.getAccessoryList();
    },
    choose_sub_accessory_category(category) {
      this.current_sub_accessory_category_id =
        this.form_data_accessory.accessory_category_id =
          category.accessory_category_id;
      this.form_data_accessory.page = 1;
      this.getAccessoryList();
    },
    async getAccessoryCategoryList() {
      this.is_loading = true;
      return AccessoryCategoryList().then((response) => {
        this.accessory_category_list = [
          { category_name: "全部", accessory_category_id: 0 },
          ...response.data,
        ];
        this.is_loading = false;
        return response;
      });
    },
    async getAccessoryLabelList() {
      this.is_loading = true;
      return AccessoryLabelList().then((response) => {
        this.accessory_label_list = [...response.data];
        this.is_loading = false;
        return response;
      });
    },
    async getAccessoryList() {
      this.is_loading = true;
      const param = {
        ...this.form_data_accessory,
        label_id: this.accessory_label_ids,
      };
      if (this.publish_time_selected.length > 0) {
        param.publish_range = this.publish_time_selected;
      }
      return AccessoryList(param).then((response) => {
        this.accessory_list = response.data.list;
        this.total = response.data.total;
        this.is_loading = false;
        return response;
      });
    },
    input2($event, field, k, child_field) {
      let object = this.form_data[field][k];
      object[child_field] = $event.target.value;
      this.$store.commit("design/arr_update_one", {
        key: field,
        index: k,
        value: object,
      });
    },
    change3($event, field, k, child_field) {
      let object = this.form_data[field][k];
      let o = object.color_list.find((v) => v.color_key == $event.target.value);
      if (o) {
        object[child_field] = $event.target.value;
        object[`color_name_cn`] = o.color_name_cn;
        object[`color_value`] = o.color_value;
      }
      this.$store.commit("design/arr_update_one", {
        key: field,
        index: k,
        value: object,
      });
    },
    onBeforeUpload(file, k) {
      uploadFileToOSS(file, "template").then((res) => {
        let object = this.form_data.accessory_self[k];
        object.image = res;
        this.$store.commit("design/arr_update_one", {
          key: "accessory_self",
          index: k,
          value: object,
        });
      });
      return false;
    },
    async processAllFiles(k) {
      const queue = [...this.uploadQueue];
      this.uploadQueue = []; // 清空队列

      console.log(`Startting upload ${queue.length} files...`);

      const newUrls = [];

      for (const file of queue) {
          try {
            const url = await uploadFileToOSS(file, "template");
            newUrls.push(url);
          } catch (err) {
            this.$layer.msg(`上传失败==>：${file.name}`);
          }
      }

      if(!newUrls.length) return;
      console.log('urls---<',newUrls);
      const currentList = this.form_data.accessory_daigou;
      if(!currentList || !currentList[k]) return;
      const currentItem = currentList[k];
      console.log('currentItem',currentItem);
      const updatedItem = {
        ...currentItem,image_list:[...(currentItem.image_list || []),...Array.from(new Set(newUrls))]
      }
      if (typeof updatedItem.currentImageIndex === 'undefined' || updatedItem.currentImageIndex === null) {
        updatedItem.currentImageIndex = 0;
      }

      console.log('updated_item',updatedItem);
      if (updatedItem.image_list.length > 0) {
        updatedItem.image = updatedItem.image_list[0];
      } else {
        updatedItem.image = "";
      }

      console.log('updated_item->image',updatedItem);

      this.$store.commit("design/arr_update_one", {
        key: "accessory_daigou",
        index: k,
        value: updatedItem,
      });

    },
    onBeforeUpload2(file, k) {
      this.uploading = true;
      // 将文件加入队列
      this.uploadQueue.push(file);

      // 清除旧定时器
      if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
      }

      // 设置新定时器：如果一段时间内没有新文件进来，则认为上传完成
      this.debounceTimer = setTimeout(() => {
          this.processAllFiles(k);
      }, this.debounceTime);
      return false;
    },
    onBeforeUpload3(file) {
      if (this.form_data.accessory_file.length >= 10) {
        this.$layer.msg(`最多可添加10个文件`);
        return;
      }
      uploadFileToOSS(file, "template").then((url) => {
        let object = { name: file.name, path: url };
        this.$store.commit("design/arr_push_one", {
          key: "accessory_file",
          value: object,
        });
      });
      return false;
    },
    del_accessory_file(k) {
      this.$store.commit("design/arr_remove_one", {
        key: "accessory_file",
        index: k,
      });
    },
  },
  mounted() {
    this.width = window.innerWidth - 220 - 490 - 30 + "px";
    axios
      .all([
        this.getAccessoryCategoryList(),
        this.getAccessoryLabelList(),
        this.onGetTeamList(),
      ])
      .then(
        axios.spread(() => {
          this.getAccessoryList();
        })
      )
      .then(async () => {
        // 先检查 localStorage 中是否有选中的辅料
        const selectedAccessoryStr = localStorage.getItem('selected_accessory');
        if (selectedAccessoryStr) {
          const selectedAccessory = JSON.parse(selectedAccessoryStr);
          console.log("[Accessory] 从 localStorage 读取到辅料:", selectedAccessory);
          
          // 清除 localStorage
          localStorage.removeItem('selected_accessory');
          
          // 处理辅料数据
          this.processSelectedAccessory(selectedAccessory);
        } else if (this.team_list.length && this.curr_team.uuid) {
          const { file } = this.$route.params;
          console.log("[Accessory] team条件满足, curr_team:", this.curr_team.uuid, 'file:', file);
          if (file && file.type == "53") {
            console.log("[Accessory] 进入处理分支, type=53, id:", file.id, 'relate_id:', file.relate_id);
            this.is_show_history = true;
            await this.onMenuChange(2);
            console.log("[Accessory] onMenuChange完成, 调用 onTeamFileChoose");
            await this.onTeamFileChoose(file);
            console.log("[Accessory] 处理完成");
          } else {
            console.log("[Accessory] 跳过 - file存在:", !!file, 'type:', file?.type);
          }
        } else {
          console.log("[Accessory] 跳过处理 - selectedAccessory:", !!selectedAccessoryStr, 'team条件:', !!this.team_list.length, 'curr_team:', !!this.curr_team.uuid);
        }
        console.log("[Accessory] emit file-data-loaded");
        this.$root.$emit('file-data-loaded');
      });
    console.log("this.form_data.accessory_page", this.form_data.package_detail);
  },
};
</script>
<style lang="scss" scoped>
.material {
  width: 100%;
  height: 100%;
  display: flex;
  column-gap: 10px;
  .main-form {
    // 【核心修改】使用 flex 替代固定 width
    // 0: 不自动增长占据多余空间
    // 1: 允许收缩
    // 400px: 基准宽度 (可根据需求调整为 488px 或更小)
    flex: 0 1 488px;
    min-width: 410px; // 防止过度收缩导致无法操作
    max-width: 488px; // 限制最大宽度，保持原有视觉比例

    height: 100%;
    overflow-y: auto;
    overflow-x: hidden; // 禁止横向滚动
    padding: 30px;
    background: #fff;
    border-right: 1px solid #f0f0f0;
    box-sizing: border-box; // 确保 padding 包含在宽度内

    &::-webkit-scrollbar {
      display: none;
    }

    .base-accessory-container {
      width: 100%;
      margin-top: 30px;
      margin-bottom:10px;
      .base-accessory-title {
        color: #000000;
        font-size: 18px;
        line-height: 1;
        padding-left: 10px;
        position: relative;
        &::before {
          content: "";
          display: inline-block;
          width: 2px;
          height: 18px;
          background: #000000;
          line-height: 18px;
          position: absolute;
          top: 50%;
          left: 0;
          transform: translate(-50%, -50%);
        }
      }
      .content-box {
        width: 100%;
        background: #f5f5f5;
        border: 1px solid #e0e0e0;
        border-radius: 5px;
        margin-top: 20px;
        .base-list-container {
          width: 100%;
          height: 286px;
          overflow-y: auto;
          .base-list {
            padding: 8px;
            display: flex;
            flex-wrap: wrap;
            gap: 7px;
            .base-item {
              width: 100px;
              border-radius: 5px;
              overflow: hidden;
              border-radius: 5px;
              border: 1px solid #e3e4e6;
              position: relative;
              .cover {
                width: 100px;
                height: 100px;
                position: relative;
                overflow: hidden;
                &:hover {
                  .cover-buttons {
                    display: block;
                  }
                }
                .cover-img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
                .replace-tag {
                  background: #fa3d5a;
                  color: #ffffff;
                  border-radius: 5px 0 5px 0;
                  font-size: 12px;
                  padding: 7px;
                  position: absolute;
                  top: 0;
                  left: 0;
                }
                .cover-buttons {
                  display: none;
                  position: absolute;
                  width: 100%;
                  height: 100%;
                  background: rgba(0, 0, 0, 0.3);
                  top: 0;
                  left: 0;
                  .btn-box {
                    width: 100%;
                    height: 100%;
                    position: relative;
                    .btn-container {
                      width: 100%;
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      column-gap: 15px;
                      .btn-item {
                        color: #ffffff;
                        font-weight: bold;
                        font-size: 14px;
                        cursor: pointer;
                      }
                    }
                  }
                }
              }
              .title {
                width: 100%;
                height: 30px;
                background: #ffffff;
                text-align: center;
                line-height: 30px;
                font-size: 12px;
                border-top: 1px solid #e3e4e6;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
              .icon-del {
                position: absolute;
                top: 6px;
                right: 6px;
                width: 18px;
                height: 18px;
              }
            }
          }
        }
        .base-replace-container {
          width: 100%;
          padding: 8px;
          .replace-title-box {
            width: 100%;
            display: flex;
            align-items: center;
            column-gap: 15px;
            padding: 12px 0;
            .replace-title-text {
              font-size: 16px;
              color: #000000;
            }
            .replace-line {
              flex: 1;
              height: 1px;
              background: #e6e6e6;
            }
          }
          .replace-list {
            // padding:8px;
            display: flex;
            flex-wrap: wrap;
            gap: 7px;
            width: 100%;
            height: 132px;
            overflow-y: auto;
            .base-item {
              width: 100px;
              border-radius: 5px;
              overflow: hidden;
              border-radius: 5px;
              border: 1px solid #e3e4e6;
              .cover {
                width: 100px;
                height: 100px;
                position: relative;
                overflow: hidden;
                &:hover {
                  .cover-buttons {
                    display: block;
                  }
                }
                .cover-img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
                .cover-buttons {
                  display: none;
                  position: absolute;
                  width: 100%;
                  height: 100%;
                  background: rgba(0, 0, 0, 0.3);
                  top: 0;
                  left: 0;
                  .btn-box {
                    width: 100%;
                    height: 100%;
                    position: relative;
                    .btn-container {
                      width: 100%;
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      column-gap: 15px;
                      .btn-item {
                        color: #ffffff;
                        font-weight: bold;
                        font-size: 14px;
                        cursor: pointer;
                      }
                    }
                  }
                }
              }
              .title {
                width: 100%;
                height: 30px;
                background: #ffffff;
                text-align: center;
                line-height: 30px;
                font-size: 12px;
                border-top: 1px solid #e3e4e6;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }

    .top-tabs {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 15px;
      border-bottom: 1px solid #e0e0e0;
      margin-bottom: 20px;
      column-gap:10px;

      .tab-list {
        display: flex;
        align-items: center;
        column-gap: 10px;
        // 防止标签换行
        white-space: nowrap;

        .tab-item {
          color: #4d4d4d;
          font-size: 16px;
          cursor: pointer;
          // 防止文字换行
          white-space: nowrap;
          text-overflow:ellipsis;
          overflow:hidden;
          &.active {
            color: #000;
            font-weight: bold;
            font-size: 18px;
          }
        }
      }

      .tab-history {
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #666;
        font-size: 12px;
        white-space: nowrap; // 防止“使用记录”换行
        text-overflow:ellipsis;
        overflow:hidden;
        flex-shrink: 0; // 防止被压缩
      }
    }

    .tips {
      font-size: 14px;
      color: red;
      font-weight: bolder;
      margin-bottom: 10px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .tips-third {
      color: #808080;
      font-size: 14px;
      text-align: center;
      margin: 15px 0;
      // 如果需要提示语也不换行，取消下面注释，但通常提示语允许换行
      // white-space: nowrap;
      // overflow: hidden;
      // text-overflow: ellipsis;
    }

    .self-tab-box {
      width: 100%;
      height: 52px;
      margin: 5px 0;
      padding: 5px 10px;
      background: #f0f1f1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;

      .self-tab-item {
        flex: 1; // 改为 flex: 1 均分空间
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 16px;
        color: #333;
        white-space: nowrap; // 防止 tab 文字换行
        overflow: hidden;
        text-overflow: ellipsis;

        &.active {
          background: #fff;
          font-weight: bold;
          color: #000;
          border-radius: 5px;
        }
      }
    }

    .main-form-title {
      color: #000;
      font-size: 18px;
      display: flex;
      align-items: center;
      column-gap: 10px;
      line-height: 18px;
      font-weight: bold;
      white-space: nowrap; // 标题不换行

      &::before {
        content: "";
        width: 2px;
        height: 18px;
        line-height: 18px;
        background: #000;
        flex-shrink: 0;
      }

      &.mt-40 {
        margin-top: 40px;
      }
    }

    .material-list {
      width: 100%;
      display: flex;
      flex-direction: column;
      row-gap: 10px;

      /*平台辅料选中列表样式开始*/
      .own-material-item {
        width: 100%;
        padding: 10px;
        position: relative;
        border: 1px solid #bfbfbf;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        overflow: hidden; // 确保圆角内内容不溢出

        .remove-icon {
          position: absolute;
          top: 12px;
          right: 12px;
          color: #b3b3b3;
          font-size: 14px;
          cursor: pointer;
          z-index: 10;
          flex-shrink: 0;
        }

        .main-info {
          width: 100%;
          display: flex;
          column-gap: 10px;

          .main-cover {
            width: 100px;
            height: 100px;
            flex-shrink: 0; // 图片区域不压缩
            position: relative;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 4px;
            }
          }

          .info-container {
            flex: 1;
            display: flex;
            flex-direction: column;
            min-width: 0; // 【关键】允许 flex 子项收缩以触发省略号
            justify-content: space-between;

            .material-title {
              color: #1a1a1a;
              font-size: 15px;
              font-weight: bold;
              // 单行超出隐藏：
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;

              // 两行超出隐藏
              // display: -webkit-box;
              // -webkit-line-clamp: 2;
              // -webkit-box-orient: vertical;
            }

            .row-1-col,
            .row-2-col {
              display: flex;
              align-items: center;
              column-gap: 5px;
              width: 100%;
              min-width: 0; // 关键

              .row-label,
              .item-label {
                color: #666;
                font-size: 13px;
                flex-shrink: 0; // 标签不压缩
                white-space: nowrap;
              }

              .row-value,
              .item-value {
                color: #1a1a1a;
                font-size: 13px;
                flex: 1;
                min-width: 0; // 关键
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;

                ::v-deep select,
                input {
                  width: 100%;
                  border: none;
                  outline: none;
                  background: transparent;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }

                ::v-deep select {
                  // select 元素比较特殊，可能需要特定样式才能完美省略
                  text-overflow: ellipsis;
                }
              }
            }

            .row-2-col {
              column-gap: 10px;
              .col-item {
                display: flex;
                align-items: center;
                column-gap: 5px;
                flex: 1;
                min-width: 0;
              }
            }
          }
        }

        .use-desc {
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          column-gap: 10px;
          background: #f5f5f5;
          border-radius: 5px;
          padding: 0 10px;
          box-sizing: border-box;
          margin-top: 10px;

          .label {
            font-size: 13px;
            flex-shrink: 0;
            white-space: nowrap;
          }

          input {
            border: none;
            outline: none;
            background: transparent;
            flex: 1;
            min-width: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      /*平台辅料选中列表样式结束*/

      /*客供辅料/代购辅料样式开始*/
      .custom-material-item {
        width: 100%;
        padding: 10px;
        position: relative;
        border: 1px solid #bfbfbf;
        border-radius: 5px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        overflow: hidden;

        .remove-icon {
          position: absolute;
          top: 12px;
          right: 12px;
          color: #b3b3b3;
          font-size: 14px;
          cursor: pointer;
          z-index: 10;
          flex-shrink: 0;
        }

        .custom-main-info {
          width: 100%;
          display: flex;
          column-gap: 10px;

          .main-cover {
            width: 100px;
            height:auto;
            min-height: 100px;
            flex-shrink: 0;
            display: flex;
            flex-direction:column;
            align-items: center;
            justify-content: center;
            position: relative;

            ::v-deep .ivu-upload {
              width: 100%;
              text-align:center;
              // height: 100%;
            }

            ::v-deep .ivu-btn-text:focus{
              box-shadow:none;
            }

            .img-box {
              width: 100%;
              height: 100%;
              position: relative;
              overflow: hidden;

              .img-list{
                width:100%;
                height:100%;
                display:flex;
                align-items:center;
                justify-content:center;
                overflow:hidden;
                img{
                  width:100%;
                  height:100%;
                  object-fit:cover;
                }
              }
              .close-btn{
                position:absolute;
                top:0;
                right:0;
                width:15px;
                height:15px;
                background:rgba(0,0,0,0.5);
                border-radius:50%;
                cursor:pointer;
                color:#fff;
                display:flex;
                align-items:center;
                justify-content:center;
                font-size:15px;
                font-weight:bold;
              }
              .replace-btn{
                position:absolute;
                bottom:0;
                left:0;
                right:0;
                height:30px;
                background:rgba(0,0,0,0.6);
                display:flex;
                align-items:center;
                justify-content:center;
                cursor:pointer;
                color:#fff;
                font-size:12px;
                transition:all 0.3s;
                .ico{
                  width:14px;
                  height:14px;
                  margin-right:4px;
                }
                &:hover{
                  background:rgba(0,0,0,0.8);
                }
              }

              .prev-btn,.next-btn{
                  position:absolute;
                  top:50%;
                  transform:translateY(-50%);
                  width:15px;
                  height:15px;
                  background:rgba(0,0,0,0.5);
                  cursor:pointer;
                  color:#fff;
                  z-index:10;
                }
                .prev-btn{
                  left:0;
                }
                .next-btn{
                  right:0;
                }
            }
            .img-default {
              width: 100%;
              height: 100%;
              background: #f5f5f5;
              border: 1px solid #e3e4e6;
              border-radius: 5px;
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              flex-direction: column;

              .img2 {
                width: 22px;
                height: 22px;
              }

              p {
                color: #666;
                font-size: 12px;
                margin-top: 4px;
                white-space: nowrap;
              }
            }
          }

          .custom-main-form {
            flex: 1;
            display: flex;
            flex-direction: column;
            row-gap: 5px;
            min-width: 0; // 关键

            .form-item {
              width: 100%;
              display: flex;
              align-items: center;
              column-gap: 10px;
              border-bottom: 1px solid #e6e6e6;
              padding-bottom: 2px;
              min-width: 0;

              .item-label {
                color: #666;
                font-size: 13px;
                flex-shrink: 0;
                white-space: nowrap;

                &.required::before {
                  content: "*";
                  color: red;
                }
              }

              input {
                flex: 1;
                border: none;
                outline: none;
                background: transparent;
                min-width: 0;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }

        .use-desc {
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          column-gap: 10px;
          background: #f5f5f5;
          border-radius: 5px;
          padding: 0 10px;
          box-sizing: border-box;
          margin-top: 10px;

          .label {
            font-size: 13px;
            flex-shrink: 0;
            white-space: nowrap;
          }

          input {
            border: none;
            outline: none;
            background: transparent;
            flex: 1;
            min-width: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      .add-custom-material {
        width: 100%;
        height: 55px;
        line-height: 55px;
        text-align: center;
        color: #666;
        font-size: 14px;
        border: 1px solid #ccc;
        border-radius: 10px;
        cursor: pointer;
        user-select: none;
        white-space: nowrap;
        box-sizing: border-box;
      }
      /*客供辅料/代购辅料样式结束*/
    }
  }
  .main-content {
    flex: 1 0 1200px;
    min-width:700px;
    width:1000px;
    height: 100%;
    min-height: 0;
    padding: 10px 65px 20px 0;
    .content-body {
      width: 100%;
      height: 100%;
      background: #fff;
      display: flex;
      flex-direction: column;
      padding: 10px;
      .body-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 5px;
        border-bottom: 2px solid #f6f7fa;
        .title {
          font-size: 20px;
          color: #1a1a1a;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-weight: bold;
        }
        .search-box {
          display: flex;
          align-items: center;
          column-gap: 10px;
          background: #f2f2f2;
          border-radius: 17px;
          padding: 8px 16px;
          input {
            flex: 1;
            border: none;
            outline: none;
            background: transparent;
          }
          .icon-search {
            width: 20px;
            height: 20px;
            cursor: pointer;
          }
        }
      }
      .content-container {
        width: 100%;
        flex: 1;
        display: flex;
        min-height: 0;
        height: 100%;
        position: relative;
        .side-category-list {
          flex: 0 0 115px;
          height: 100%;
          overflow-y: auto;
          display: flex;
          flex-direction: column;
          padding: 15px 0;
          border-right: 1px solid #f6f7fa;
          .category-item {
            width: 80px;
            min-height: 35px;
            display:flex;
            align-items:center;
            justify-content:center;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
            color: #1c1c1c;
            border-radius: 5px;
            &.active {
              color: #fff;
              background: #000;
            }
          }
        }
        .content-body-container {
          flex: 1;
          display: flex;
          flex-direction: column;
          row-gap: 20px;
          //   height:100%;
          min-height: 0;
          padding: 20px 20px 0 10px;
          .top-category-list {
            width: 100%;
            min-height: 0;
            display: flex;
            flex-direction: column;
            row-gap: 5px;
            &.show-first{
              overflow:hidden;
              max-height:30px;
            }
            .top-cate-item {
              display: flex;
              align-items: flex-start;
              column-gap: 10px;
              font-size: 14px;
              .top-cate-label {
                color: #666;
                flex-shrink:0;
                white-space:nowrap;
              }
              .top-cate-list {
                display: flex;
                align-items: center;
                flex-wrap:wrap;
                gap: 5px;
                .cate-list-item {
                  color: #333;
                  padding: 1px 10px;
                  border-radius: 10px;
                  cursor: pointer;
                  &.active {
                    background: #ffecee;
                    color: #fa3d5a;
                    font-weight: 500;
                  }
                }
              }
            }
          }
          .list-container {
            flex: 1;
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            gap:15px;
            align-content:flex-start;
            background: #f6f7fa;
            border-radius: 5px;
            border: 1px solid #ebedf2;
            padding: 15px;
            overflow-y: auto;
            .list-item {
              flex: 0 0 calc(100% / 5 - 15px);
              height: 160px;
              border: 1px solid #e3e4e6;
              border-radius: 5px;
              display: flex;
              flex-direction: column;
              background: #fff;
              position: relative;
              cursor: pointer;
              overflow: hidden;
              box-sizing:border-box;
              &.active {
                border: 1px solid #fa3d5a;
              }
              .inventory-type-tag {
                position: absolute;
                top: 0;
                left: 0;
                color: #ffffff;
                background: #fa3d5a;
                border-top-left-radius: 5px;
                border-bottom-right-radius: 5px;
                padding: 0 10px;
                z-index: 101;
              }
              .check-icon {
                width: 25px;
                height: 25px;
                position: absolute;
                top: 0;
                right: 0;
                z-index: 3;
                display: block;
                box-sizing: border-box;
              }
              .cover-img-box {
                width: 100%;
                height: 126px;
                border-radius: 5px 5px 0 0;
                overflow: hidden;
                position: relative;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                  border-radius: 5px 5px 0 0;
                }
                &:hover .img-hover {
                  position: absolute;
                  inset: 0;
                  width: 100%;
                  height: 100%;
                  border-radius: 5px 5px 0 0;
                  background: rgba(0, 0, 0, 0.5);
                  display: flex;
                  align-items: flex-end;
                  padding: 0 10px;
                  .hover-btn-box {
                    width: 100%;
                    padding-bottom: 5px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    .hover-btn-item {
                      color: #fff;
                      font-size: 14px;
                      font-weight: bold;
                      cursor: pointer;
                    }
                  }
                }
              }
              .name-box {
                width: 100%;
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                color: #616366;
                font-size: 12px;
                border-top: 1px solid #e3e4e6;
                span {
                  display: block;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
        .wearhouse-body {
          width: 100%;
          display: flex;
          flex-direction: column;
          margin-top: 20px;
          .container-tabs {
            display: flex;
            align-items: center;
            column-gap: 16px;
            width: 100%;
            .tab-item {
              color: #666;
              font-size: 14px;
              line-height: 32px;
              padding: 0 16px;
              cursor: pointer;
              &.active {
                color: #fff;
                background: #ff5967;
              }
            }
          }
          .container-wh-list {
            width: 100%;
            flex: 1;
            // min-height:432px;
            // max-height:632px;
            background: #f6f7fa;
            margin-top: 16px;
            overflow-y: auto;
            padding: 20px;
            display: flex;
            flex-wrap: wrap;
            gap: 28px;
            .list-item {
              // width:142px;
              width: calc(100% / 6 - 28px);
              height: 175px;
              border: 1px solid #e3e3e3;
              border-radius: 6px;
              background: #fff;
              .cover-img {
                width: 100%;
                height: 142px;
                overflow: hidden;
                border-radius: 6px 6px 0 0;
                position: relative;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  object-position: center;
                }
                &:hover .operate-btn {
                  width: 100%;
                  height: 100%;
                  background: rgba(0, 0, 0, 0.4);
                  padding: 0 8px;
                  display: flex;
                  align-items: flex-end;
                  justify-content: space-between;
                  position: absolute;
                  top: 0;
                  left: 0;
                  // left:0;
                  // bottom:8px;
                  .btn-item {
                    cursor: pointer;
                    color: #fff;
                    font-size: 14px;
                  }
                }
              }
              .item-name {
                width: 100%;
                padding: 6px 8px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
            }
          }
        }

        .color-mask {
          position: absolute;
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.35);
          z-index: 200;
          .color-wrap {
            position: absolute;
            width: 600px;
            height: 300px;
            top: calc(50% - 150px);
            left: calc(50% - 300px);
            background: white;
            border-radius: 10px;
            z-index: 10000;
            padding: 20px 10px 0 10px;

            .title {
              font-size: 16px;
              font-weight: bold;
              color: #1a1a1a;
            }

            .color-list {
              display: flex;
              flex-wrap: wrap;
              width: 560px;
              height: 100%;
              min-height: 150px;
              max-height: 170px;
              overflow-y: auto;
              row-gap: 10px;

              .color-item {
                width: 120px;
                height: 46px;
                border: 1px solid #e5e5e5;
                border-radius: 5px 5px 5px 5px;
                margin: 0 8px;
                display: flex;
                align-items: center;
                padding: 0 5px;
                cursor: pointer;

                img {
                  width: 30px;
                  height: 30px;
                  margin-right: 5px;
                }

                &.active {
                  border-color: #fa3d5a;

                  span {
                    color: #fa3d5a;
                  }
                }
              }
            }

            .btn-group {
              margin-top: 24px;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              border-top: 1px solid #e5e5e5;
              height: 58px;

              .btn {
                width: 100px;
                height: 38px;
                line-height: 38px;
                border-radius: 5px;
                text-align: center;
                font-size: 14px;
                margin: 0 7px;
                cursor: pointer;

                &.btn-cancel {
                  color: black;
                  border: 1px solid #e5e5e5;
                }

                &.btn-confirm {
                  color: white;
                  background: #fa3d5a;
                }
              }
            }
          }
        }
      }
      .daigou-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
        .daigou-img {
          width: 50px;
          height: 50px;
          margin-bottom: 29px;
        }
        .daigou-sub-title {
          color: #1a1a1a;
          font-weight: 500;
          font-size: 22px;
          margin-bottom: 28px;
        }
        p {
          color: #4d4d4d;
          font-size: 14px;
          line-height: 30px;
        }
      }
      .history-team-box {
        display: flex;
        border-top: 1px solid #f6f7fa;
        margin-top: 14px;
        .my-pattern-menu {
          flex: 1;
          max-width: 198px;
          height: 100%;
          display: flex;
          flex-direction: column;
          row-gap: 10px;
          padding: 0 20px;
          margin-top: 9px;
          .menu-parent-item {
            width: 100%;
            height: 35px;
            display: flex;
            align-items: center;
            column-gap: 10px;
            color: #1c1c1c;
            font-size: 14px;
            padding-left: 10px;
            padding-right: 4px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            cursor: pointer;
            &.active {
              background: #1c1c1c;
              border-radius: 5px;
              color: #ffffff;
            }
            .menu-icon {
              width: 20px;
              height: 20px;
            }
            .label-name {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: space-between;
            }
          }
          ul {
            margin-left: 39px;
            li {
              list-style-type: square;
              position: relative;
              cursor: pointer;
              color: #4d4d4d;
              font-size: 14px;
              line-height: 40px;
              span {
                display: block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: 100%;
              }

              &::marker {
                font-size: 18px;
              }

              &:hover,
              &.active-team {
                color: #ff5967;
              }
            }
          }
        }

        .history-tag-box {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          margin-top: 13px;
          // margin-bottom:15px;
          .history-tab {
            display: flex;
            align-items: center;
            gap: 20px;
            .tag-item {
              color: #4d4d4d;
              font-size: 14px;
              padding: 9px 16px;
              cursor: pointer;
              &.active {
                // background:#1c1c1c;
                // color:#ffffff;
                // border-radius:5px;
                color: #fb486d;
                font-weight: bold;
                border-radius: 24px;
                background: rgba(251, 72, 109, 0.1);
              }
            }
          }

          .batch-box {
            display: flex;
            align-items: center;
            font-size: 14px;
            justify-content: flex-end;
            column-gap: 20px;
            .batch-btn {
              color: #666666;
              cursor: pointer;
            }
          }

          .tag-item-folder {
            color: #4d4d4d;
            font-size: 14px;
            padding: 8px 16px;
            cursor: pointer;
            &.folder-item-active {
              color: #fb486d;
              font-weight: bold;
              border-radius: 24px;
              background: rgba(251, 72, 109, 0.1);
            }
          }
        }

        table {
          display: table;
          width: 100%;
          table-layout: fixed;
          margin-top: 15px;
          border-collapse: collapse;

          thead {
            display: table;
            table-layout: fixed;
            width: 100%;

            tr {
              background: #fafafa;
              color: #808080;

              th {
                padding: 19px 0;
                text-align: center;
                // 使用 flex 分配宽度比例，假设总共 10 份
                // 第一列：辅料信息 (40%)
                &:nth-child(1) {
                  width: 40%;
                }
                // 第二列：订单信息 (40%)
                &:nth-child(2) {
                  width: 40%;
                }
                // 第三列：操作 (20%)
                &:nth-child(3) {
                  width: 20%;
                }
              }
            }
          }

          tbody {
            display: block;
            width: 100%;
            height: 50vh;
            overflow-y: auto;

            &::-webkit-scrollbar {
              display: none;
            }

            tr {
              width: 100%;
              display: table;
              table-layout: fixed;

              &:hover {
                background: #fafafa;
              }

              td {
                padding: 15px 0;
                text-align: center;
                vertical-align: middle; // 增加垂直居中

                // 第一列：辅料信息
                &:nth-child(1) {
                  width: 40%;

                  .info-box {
                    display: flex;
                    align-items: center;
                    justify-content: center; // 或者 flex-start，看设计需求
                    column-gap: 10px;
                    width: 100%; // 改为 100% 以填充单元格
                    padding: 0 10px; // 增加内边距防止贴边

                    .cover-img {
                      width: 50px;
                      height: 50px;
                      min-width: 50px; // 防止压缩
                      border-radius: 5px;
                      border: 1px solid #e3e4e6;
                      background: #ffffff;
                      object-fit: cover;
                    }

                    .info {
                      display: flex;
                      flex-direction: column;
                      align-items: flex-start;
                      justify-content: center;
                      text-align: left;
                      row-gap: 3px;
                      flex: 1; // 占据剩余空间
                      min-width: 0; // 关键：允许 flex 子项收缩以触发省略号

                      .info-title {
                        color: #1a1a1a;
                        font-size: 14px;
                        width: 100%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        .title-tag {
                          font-size: 12px;
                          margin-left: 4px;
                          &.platform {
                            color: #0caea8;
                          }
                          &.custom {
                            color: #3f7aca;
                          }
                        }
                      }

                      .info-key {
                        color: #666666;
                        font-size: 12px;
                        width: 100%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      }
                    }
                  }
                }

                // 第二列：订单信息
                &:nth-child(2) {
                  width: 40%;

                  // 针对订单信息内部结构的优化
                  > div {
                    text-align: left;
                    padding: 0 20px; // 增加左右内边距
                    width: 100%;

                    p {
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      margin: 2px 0;

                      span {
                        color: #999;
                        margin-right: 5px;
                      }
                    }
                  }
                }

                // 第三列：操作
                &:nth-child(3) {
                  width: 20%;

                  .operation-col {
                    display: flex;
                    flex-direction: column; // 改为垂直排列可能更适合窄列，或者保持 row 但换行
                    align-items: center;
                    justify-content: center;
                    gap: 5px;
                    width: 100%;

                    .operation {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      column-gap: 5px;

                      span {
                        font-size: 12px;
                        color: #cccccc;
                      }

                      .btn {
                        color: #666666;
                        font-size: 12px;
                        white-space: nowrap;
                        cursor: pointer;
                        padding: 2px 5px; // 增加点击区域

                        &:hover {
                          color: #fa424f;
                        }
                      }
                    }

                    .join-team {
                      color: #666666;
                      font-size: 12px;
                      cursor: pointer;
                      white-space: nowrap;

                      &:hover {
                        color: #fa424f;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .team-file {
          table {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0 9px;
            table-layout: fixed;
            border: none;
            thead {
              text-align: center;
              tr {
                background: #fcfcfd;
                border-radius: 5px;
                height: 36px;
                th {
                  color: #808080;
                  font-size: 14px;
                  line-height: 36px;
                }
              }
            }

            tbody {
              tr {
                border-radius: 5px;
                overflow: hidden;
                background-color: white;
                cursor: pointer;
                &:hover {
                  background: #fafafa;
                }
                &.tr-active {
                  outline: 1px solid #ff5967;
                  position: relative;
                }
                td {
                  position: relative;
                  .selected-icon {
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 25px;
                    height: 25px;
                  }
                  .info-container {
                    padding: 8px;
                    display: flex;
                    align-items: center;
                    column-gap: 14px;
                    .cover-img {
                      width: 50px;
                      height: 50px;
                      border-radius: 3px;
                      border: 1px solid #e3e4e6;
                      flex-shrink: 0;
                    }
                    .item-info {
                      display: flex;
                      flex-direction: column;
                      row-gap: 10px;
                      // width:100%;
                      flex: 1;
                      .title {
                        display: flex;
                        align-items: center;
                        .main {
                          color: #1a1a1a;
                          font-size: 14px;
                          font-weight: bold;
                          width: fit-content;
                          text-overflow: ellipsis;
                          overflow: hidden;
                          white-space: nowrap;
                        }
                        .sub {
                          font-size: 12px;
                          margin-left: 5px;
                          flex-shrink: 0;
                          &.custom-pattern {
                            color: #3f7aca;
                          }
                          &.own-pattern {
                            color: #0caea8;
                          }
                        }
                      }
                      .info {
                        color: #666666;
                        font-size: 12px;
                        line-height: 20px;
                        width: 100%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        text-align: left;
                      }
                    }
                  }
                  .style-col {
                    width: 100%;
                    text-align: center;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                  .operation-col {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    column-gap: 40px;
                    .left-operation {
                      display: flex;
                      align-items: center;
                      column-gap: 10px;
                      font-size: 12px;
                      .btn {
                        cursor: pointer;
                        color: #666666;
                        &.btn-active,
                        &:hover {
                          color: #fa3d5a;
                        }
                      }
                      .line {
                        color: #cccccc;
                      }
                    }
                    .add-to-team {
                      color: #666666;
                      font-size: 12px;
                      cursor: pointer;
                      &:hover {
                        color: #fa3d5a;
                      }
                    }
                  }
                }
              }
            }

            /* 设置单元格的样式以配合圆角效果 */
            td,
            th {
              border: none;
              // border: 1px solid #e8eaec;
              padding: 8px;
              &:first-child {
                border-radius: 5px 0 0 5px; /* 第一列单元格左上、左下圆角 */
              }
              &:last-child {
                border-radius: 0 5px 5px 0; /* 最后一列单元格右上、右下圆角 */
              }
              &:first-child:last-child {
                border-radius: 5px; /* 只有一个单元格时应用全部圆角 */
              }
            }
          }
        }
        .page-container {
          width: 100%;
          border-top: 1px solid #e0e0e0;
        }
      }
    }
  }
}

.flex-container{
  display:flex;
  align-items:center;
  justify-content:space-between;
}

.show-more-cate{
  width:88px;
  height:28px;
  border-radius:4px;
  display:flex;
  align-items:center;
  justify-content:center;
  column-gap:4px;
  font-size:14px;
  cursor:pointer;
  color:#333;
  border:1px solid #e3e3e3;
  user-select:none;
  &.show-all{
    color:#ff5967;
    border:1px solid #ff5967;
  }
}

.upload-other {
  width: 100%;
  height: 56px;
  border-radius: 5px;
  border: 1px solid #b3b3b3;
  color: #1d1d1d;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  cursor: pointer;
  .icon {
    width: 24px;
    height: 24px;
  }
}

.other-file-list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  .file-box {
    display: flex;
    align-items: center;
    width: 100%;
    height: 42px;
    background: #f3f3f3;
    position: relative;
    margin: 10px 5px;
    .file-item {
      position: relative;
      line-height: 42px;
      color: #1a1a1a;
      font-size: 12px;
      padding-left: 55px;
      .icon-doc {
        position: absolute;
        top: 5px;
        left: 15px;
        width: 32px;
        height: 32px;
      }
    }
    .icon-del {
      position: absolute;
      top: 12px;
      right: 15px;
      width: 20px;
      height: 20px;
      z-index: 10;
    }
    .replace-file {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100px;
      background: rgba(0, 0, 0, 0.4);
      color: #ffffff;
      font-size: 13px;
      cursor: pointer;
      .ico {
        width: 18px;
        height: 18px;
      }
    }
  }
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}

::v-deep .popup-modal {
  /* 核心容器 */
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);

  /* 弹窗内容区 */
  .popup-content {
    background: #fff;
    border-radius: 10px;
    //   width: min(980px, 92vw); // 最大980px，最小占92%视口宽
    /* 修正后 */
    width: max(980px, 96vw); // 增加视口占比
    min-width: 320px; // 保障最小可操作宽度
    max-width: none !important; // 移除潜在限制

    /* 添加边距保护 */
    margin: 0 2vw; // 左右留白
    box-sizing: content-box; // 防止padding影响
    max-height: max(720px, 85vh); // 最大720px，最小占85%视口高
    min-height: 30vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
}

.fabric-content-wrap {
  margin-top: 40px;
  height: 600px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .popup-scroll-content {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
  }
  .title-box {
    display: flex;
    align-items: center;
    column-gap: 13px;
    .title {
      color: #1a1a1a;
      font-size: 16px;
      border-left: none;
      font-weight: bold;
      margin-bottom: 0;
      padding: 10px 0;
      height: auto;
    }
    .line {
      flex: 1;
      height: 1px;
      background: #ebebeb;
    }
  }

  .info-wrap {
    display: flex;
    justify-content: space-around;
    min-height: 430px;

    .left-popup {
      width: 420px;
      border: 1px solid #e5e5e5;
      .f-img {
        width: 420px;
        height: 420px;
      }
    }

    .right {
      // width: 500px;
      flex: 1;
      padding-right: 20px;
      padding-left: 20px;
      .name {
        color: #1a1a1a;
        font-size: 20px;
      }

      .no {
        color: #808080;
        font-size: 14px;
        margin-bottom: 20px;
        // margin: 25px 0;
      }
      .price {
        color: #e00000;
        font-size: 18px;
        font-weight: bold;
        padding-bottom: 17px;
      }
      .item {
        margin: 5px 0;

        .key {
          display: inline-block;
          color: #808080;
          // width: 80px;
        }

        .value {
          color: #1a1a1a;
        }
      }
      .color-title {
        color: #1a1a1a;
        font-size: 16px;
        font-weight: bold;
      }
      .color-box {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        column-gap: 10px;
        row-gap: 10px;
        margin-top: 26px;
        max-height: 200px;
        overflow-y: auto;
        .color-item {
          width: 112px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          column-gap: 6px;
          border-radius: 5px;
          border: 1px solid #e5e5e5;
          color: #4d4d4d;
          cursor: pointer;
          .color-img {
            width: 25px;
            height: 25px;
            border-radius: 5px;
          }
          &.active {
            border: 1px solid #fa3d5a;
            color: #fa3d5a;
          }
        }
      }
    }
  }

  .color-box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    column-gap: 10px;
    row-gap: 10px;
    .color-item {
      width: 112px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 6px;
      border-radius: 5px;
      border: 1px solid #e5e5e5;
      color: #4d4d4d;
      cursor: pointer;
      .color-img {
        width: 25px;
        height: 25px;
        border-radius: 5px;
      }
      &.active {
        border: 1px solid #fa3d5a;
        color: #fa3d5a;
      }
    }
  }

  .richtext-wrap {
    padding-bottom: 20px;
  }
  .btn-box {
    display: flex;
    justify-content: center;
    column-gap: 20px;
    flex-shrink: 0;
    background: #ffffff;
    padding: 10px 0;
    border-top: 1px solid #ebebeb;
    .cancel-btn {
      width: 120px;
      height: 38px;
      border-radius: 19px;
      background: #ffffff;
      border: 1px solid #e5e5e5;
      color: #1a1a1a;
      font-size: 14px;
      cursor: pointer;
    }
    .confirm-btn {
      width: 120px;
      height: 38px;
      border-radius: 19px;
      background: #1a1a1a;
      color: #ffffff;
      font-size: 14px;
      cursor: pointer;
    }
  }
}

.slider {
  width: 420px;
  height: 420px;
  overflow: hidden;

  .swiper-slide {
    width: 420px;
    height: 420px;
  }

  .img,
  video {
    width: 420px;
    height: 420px;
    object-fit: contain;
  }
}

::v-deep .viewer-container {
  z-index: 999999 !important;
}

::v-deep .ivu-upload {
  width: 100%;
}

select {
  width: fit-content;
  height: 25px;
  border-radius: 5px;
  border: none;
  outline: none;
}
</style>
